define('viewmodels/VisualAnalytics/ControlSetup',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, app, appsecurity, navigation, system, logger, ObjGeneralSettings, utils) {
        var responseLevel, AmlCaViewModel = {
            attached: attached,
            detached: detached,
            activate: activate,
            appsecurity: appsecurity,
            utils: utils,
            AssessmentType: ko.observable("AML"),
            ControlSubAreaExhaustiveList: ko.observableArray(),
            ControlSubAreaList: ko.observableArray(),
            SelectedControlArea: ko.observable(),
            SelectedControlSubArea: ko.observable(),
            ControlAreaPopUpType: ko.observable(),
            ControlAreaPopUpTitle: ko.observable(),
            popUpTitle: ko.observable(),
            CancelRiskQuestionSortOrder: CancelRiskQuestionSortOrder,
            ControlAreaPopUpData: ko.observable(),
            addPopUpCss: ko.observable(),
            OpenSortOrderQuestionPopUp: OpenSortOrderQuestionPopUp,
            CDChecked: ko.observable(),
            DownFunctionalityRiskAreaQuestion: DownFunctionalityRiskAreaQuestion,
            UpFunctionalityRiskAreaQuestion: UpFunctionalityRiskAreaQuestion,
            SaveRiskQuestionSortOrder: SaveRiskQuestionSortOrder,
            OEChecked: ko.observable(),
            ControlSaveDisabled: ko.observable(),
            ControlAreaSortOrder: ko.observable(),
            ControlSubAreaSortOrder: ko.observable(),
            ControlsAccess: ko.observable(false),
            lengthofdeletedarea: ko.observable(),
            ControlQuestionList: ko.observable(),
            AddControlQuestionPopUp: AddControlQuestionPopUp,
            EditControlQuestionPopUp: EditControlQuestionPopUp,
            ControlQuestionPopUpType: ko.observable(),
            ControlSubAreaPopUpType: ko.observable(),
            ControlQuestionPopUpTitle: ko.observable(),
            ControlQuestionPopUpData: ko.observable(),
            ControlQuestionPopUpAreasApplicable: ko.observable(),
            ClickedRiskArea: ko.observable(),
            Isrequest: ko.observable(),
            ControlQuestionSortOrder: ko.observable(),
            RiskAreaReorderList: ko.observableArray(),
            RiskSubAreaReorderList: ko.observableArray(),
            RiskQuestionReorderList: ko.observableArray(),
            RiskQuestionReorderListDup: ko.observableArray(),
            RiskAreaReorderListDup: ko.observableArray(),
            RiskSubAreaReorderListDup: ko.observableArray(),
            CurrentScreenName: ko.observable(''),
            FreezeConfigurationsByScreen: FreezeConfigurationsByScreen,
            ResponseAddButton: ResponseAddButton,
            ControlResponseList: ko.observableArray(),
            ControlResponseListDup: ko.observableArray(),
            deleteResponseItem: deleteResponseItem,
            AddNewLevelCount: ko.observable(-1),
            SaveResponses: SaveResponses,
            SavelvlResponses: SavelvlResponses,
            ratingApplicability: ko.observable(false),
            DeleteResponses: DeleteResponses,
            CancelResponses: CancelResponses,
            CloseModel: CloseModel,
            AssessmentTypeList: ko.observableArray(),
            SelectedAssessmentType: ko.observable([]),
            QuestionAssessmentTypeList: ko.observable(),
            SelectedAssessmentTypeQuestion: ko.observable(),
            EditAreaVisible: ko.observable(),
            OpenConfigureResponseLevelsPopup: OpenConfigureResponseLevelsPopup,
            ControlAreaResponseLevelPopup: ko.observable(),
            ControlResponselvlList: ko.observableArray([]),
            DeletelvlResponses: DeletelvlResponses,
            ResponselvlAddButton: ResponselvlAddButton,
            trclick: trclick,
            ResposneSublevelList: ko.observableArray([]),
            addSubResponseFunctionality: addSubResponseFunctionality,
            deleteSubResponseFunctionality: deleteSubResponseFunctionality,
            SaveSubResponseFunctionality: SaveSubResponseFunctionality,
            SelectedResponseId: ko.observable(),
            SelectedResponseType: ko.observable(),
            NAChecked: ko.observable(false),
            LanguageList: ko.observableArray(),
            ObjGeneralSettings: ObjGeneralSettings,
            RiskAreaSubList: ko.observableArray(),
            LanguageControlAreaDropdownVisible: ko.observable(true),
            SelectedLanguageControlAreaType: ko.observableArray([]),
            SelectedLanguageControlSubAreaType: ko.observableArray([]),
            ControlAreaSubList: ko.observableArray(),
            ControlSubAreaSubList: ko.observableArray(),
            LanguageCntrlFactorDdVisible: ko.observable(false),
            SelectedLanguageCntrlFactorType: ko.observableArray([]),
            CntrlFactorLanguageAdded: CntrlFactorLanguageAdded,
            ControlLanguageFactorList: ko.observableArray(),
            SelectedResponseOptionType: ko.observableArray([]),
            SelectedResponseOption: ko.observableArray([]),
            SelectedParentResponseOption: ko.observableArray([]),
            CntrlFactorResponseSelected: CntrlFactorResponseSelected,
            EditControlQuestionList: ko.observableArray(),
            ControlQuestionLanguageSuList: ko.observableArray(),
            ControlQUestionSubList: ko.observableArray(),
            ControlAddQuestionList: ko.observableArray(),
            LanguageFactorModel: LanguageFactorModel,
            AddDynamicControlQuestion: AddDynamicControlQuestion,
            AlphaNumbers: ko.observable(/^[a-zA-Z0-9]+$/),
            QuestionTypeChangedFactor: QuestionTypeChangedFactor,
            FactorReadOnlyType: ko.observable(false),
            FactorHeaderType: ko.observable(false),
            FactorConditionalType: ko.observable(false),
            ControlQuestionType: ko.observable(false),
            AddConditionalQuestionType: ko.observable(false),
            SelectedSubResponseOptionType: ko.observableArray([]),
            AddConditionalQuestionPopUp: AddConditionalQuestionPopUp,
            ResponseOptionddFlag: ko.observable(false),
            ResposneAddSublevelList: ko.observableArray(),
            ParentResposneAddSublevelList: ko.observableArray(),
            GetAllSubResponsesForConditionalType: GetAllSubResponsesForConditionalType,
            ControlQuestionId: ko.observable(),
            ControlQuestionName: ko.observable(),
            resetRadioButtons: resetRadioButtons,
            controlResponseTypesAdd: ko.observable(true),
            ClickedAssessmentTypeId: ko.observable(),
            AssessmentTypeClick: AssessmentTypeClick,
            ControlAreaListAsPerAssessmentType: ko.observableArray(),
            ControlQuestionListAsPerAssessmentType: ko.observableArray(),
            GetControlQuestionSortOrder: GetControlQuestionSortOrder,
            SelectedSubAreaAssessmentType: ko.observableArray(),
            SelectedSubAreaAssessmentTypeEdit: ko.observableArray(),
            AssessmentTypeListForSubArea: ko.observableArray(),
            ClickedRiskSubArea: ko.observable(),
            SaveEditControlQuestionPopUp: SaveEditControlQuestionPopUp,
            ControlResponseApplicabilityList: ko.observableArray(),
            SelectedResponseApplicabilityType: ko.observableArray([]),
            CntrlChangeInResponseApplicability: CntrlChangeInResponseApplicability,
            NewResponseLevelModel: ko.observable(),
            SelectedLanguageForResponseLevel: ko.observableArray(),
            ResponseLevelLanguageAdded: ResponseLevelLanguageAdded,
            SaveResponseSubLevel: SaveResponseSubLevel,
            GlobalResponses: ko.observable(false),
            RowExpandClick: RowExpandClick,
            QuestionResponsesList: ko.observableArray(),
            SelectedResponseRow: ko.observableArray([]),
            AddResponsePopUp: AddResponsePopUp,
            ResponseValueListForQuestion: ko.observableArray([]),
            SaveQuestionResponseSubLevel: SaveQuestionResponseSubLevel,
            ControlResponseLocalPopupType: ko.observable(),
            ControlResponseLocalPopupTitle: ko.observable(),
            EditResponsePopUp: EditResponsePopUp,
            isGlobalFlag: ko.observable(true),
            ResponseWithWeights: ko.observable(false),
            SelectedResponseValues: ko.observableArray([]),
            isGlobalFlagCopy: ko.observable(),
            uploadDownloadDetails: ko.observable(),
            RATActionChanged: RATActionChanged,
            ZATRATList: ko.observableArray([]),
            ZATRATListDup: ko.observableArray([]),
            ZATListSubArea: ko.observableArray([]),
            ZATDropDownList: ko.observableArray([]),
            ZATDropDownListSubArea: ko.observableArray([]),
            ZATRATListLength: ko.observable(),
            SelectedZATDropDownList: ko.observableArray([]),
            SelectedZATRATList: ko.observableArray([]),
            SelectedAssessmentTypeEdit: ko.observableArray([]),
            SelectedZATDropDownListEdit: ko.observableArray([]),
            SelectedZATDropDownListSubArea: ko.observableArray([]),
            SelectedZATDropDownListSubAreaEdit: ko.observableArray([]),
            AssessmentTypeListModified: ko.observableArray([]),
            ZATDropDownListModified: ko.observableArray([]),
            SurveyCategoryList: ko.observableArray([]),
            SurveyCategoryTabClick: SurveyCategoryTabClick,
            SelectedSurveyCategoryDetails: ko.observable(),
            ControlQuestionPop: ko.observable(),
            HideFilterDiv: HideFilterDiv,
            ShowFilterDiv: ShowFilterDiv,
            AreaLeveljstree: ko.observable(),
            SelectedRiskAreaId: ko.observable(),
            SelectedRiskAreaName: ko.observable(),
            CurrentRiskAreaTypeList: ko.observable(),
            ToggleNavigationMenu1: ToggleNavigationMenu1,
            ToggleNavigationMenu2: ToggleNavigationMenu2,
            CollapseAllTreeView: CollapseAllTreeView,
            ExpandAllTreeView: ExpandAllTreeView,
            BreadCrumbArray: ko.observableArray([]),
            truncate: truncate,
            QuestionGuideline: ko.observable(),
            ConfigureInstructions: ConfigureInstructions,
            SaveInstructions: SaveInstructions,
            Instructions: ko.observable(),
            GetAllOptionsType: GetAllOptionsType,
            OptionsTypeList: ko.observableArray([]),
            //selectedOptionType: ko.observable(),
            changedResponseType: changedResponseType,
            ResponseOptionList: ko.observableArray([]),
            ResponseUneditableText: ko.observable(),
            copyOverResponse: ko.observable(false),
            hasChildNodes: ko.observable(false),
            SelectedScenarioId: ko.observable(),
            AssessmentTypeId: ko.observable(),
            GetSurveyCategoryControlTabsCS: GetSurveyCategoryControlTabsCS,

            LocaleCheckFlag: ko.observable(false)
        };
        return AmlCaViewModel;
        function detached() {
            $($(document.getElementsByClassName('list-group-item')).get(1)).removeClass('active');
        }
        function activate(data) {

            if (AmlCaViewModel.ObjGeneralSettings === undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AmlCaViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                AmlCaViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() == null || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        AmlCaViewModel.LocaleCheckFlag(false);
                    else
                        AmlCaViewModel.LocaleCheckFlag(true);
                });
            } else
                AmlCaViewModel.LocaleCheckFlag(true);

        }
        function attached() {
            try {

                if (AmlCaViewModel.ObjGeneralSettings === undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AmlCaViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    AmlCaViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList() == null || AmlCaViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            AmlCaViewModel.LocaleCheckFlag(false);
                        else
                            AmlCaViewModel.LocaleCheckFlag(true);
                    });
                }

                var url = window.location.pathname;
                AmlCaViewModel.SelectedSurveyCategoryDetails();
                GetLanguages();
                //GetSurveyCategoryControlTabs(AssessmentId, StateSelected);
                GetAllSurveyCategories();
                GetResponseLevels();
                GetAllOptionsType();
                AmlCaViewModel.CurrentScreenName(url.substring(url.lastIndexOf('/') + 1));
                //appsecurity.GetConfigurationFreezeFlag().then(function () {
                AmlCaViewModel.ControlsAccess(true);
                //});

                //GetConfigurationFreezeStatusByScreen();
                $($(document.getElementsByClassName('list-group-item')).get(1)).addClass('active');
                AmlCaViewModel.Isrequest(0);
                $("#divNavSwitch2").hide();
                $("#ControlsContent").hide();

                //CKEDITOR.config.removeButtons='Copy,Cut,Paste,Undo,Redo,Print,Form,TextField,Textarea,Button,SelectAll,NumberedList,BulletedList,CreateDiv,Table,PasteText,PasteFromWord,Select,HiddenField,Anchor';
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetSurveyCategoryControlTabsCS(AssessmentId, StateSelected, ScenarioId) {
            try {

                AmlCaViewModel.AssessmentTypeId(AssessmentId);

                AmlCaViewModel.SelectedScenarioId(ScenarioId);

                $.ajax({
                    url: "/api/Visualization/GetSurveyCategoryTabsByZATRAT",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": AssessmentId, "StateSelected": StateSelected }
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult.length !== 0 && jsonResult !== null) {
                            $('#NoComponentDataDiv').hide();
                            var mappedTabList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            AmlCaViewModel.SurveyCategoryList(mappedTabList);
                            $('#AssessmentTypeTab').tabs();
                            $('#AssessmentTypeTab').tabs('refresh');
                            $('#AssessmentTypeTab').tabs({ active: 0 });
                            $($('#AssessmentTypeTab li').get(0)).trigger('click');
                            $("#AssessmentTypeTab").removeClass('ui-widget-content');
                            $("#RiskLevelTab").removeClass('ui-widget-content');

                            scrollableTabs();
                            $('#loadingMainImgDiv').hide();
                        }
                        else {
                            $('#loadingImgMainTab').hide();
                            $('#NoComponentDataDiv').show();
                        }
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in InherentSetup.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryControlTabs() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetAllAssessmentTypes() {
            try {
                $.ajax({
                    url: "/api/Visualization/GetAssessmentTypesByCategory",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "ZATId": AmlCaViewModel.SelectedSurveyCategoryDetails().SurveyCategoryId(), "ScenarioId": AmlCaViewModel.SelectedScenarioId() }

                })
                    .success(function (jsonResult, error) {
                        AmlCaViewModel.AssessmentTypeList([]);
                        if (jsonResult != null) {
                            var AssessmentIdArray = [];

                            var MappedAssessmentList = $.map(jsonResult, function (result) {
                                AssessmentIdArray.push(result.AssessmentId);
                                return new AssessmentListModel(result);
                            });
                            AmlCaViewModel.AssessmentTypeList(MappedAssessmentList);
                            InitiateAreaLevelTree(AssessmentIdArray.join());

                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ToggleNavigationMenu1() {
            var chk2 = $('#NavigationToggle2');
            chk2.prop("checked", false);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
            $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
            $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
            $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").show();
            $("#divjsTree").hide();
        }
        function ToggleNavigationMenu2() {
            var chk1 = $('#NavigationToggle1');
            chk1.prop("checked", true);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
            $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
            $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
            $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").hide();
            $("#divjsTree").show();
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == "Expand") {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text("Collapse");
            }
            else {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text("Expand");
            }
        }
        function ExpandAllTreeView() {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
        }

        function InitiateAreaLevelTree(AssessmentIdList) {
            try {
                $('#ControlsContent').hide();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {
                    url: "/api/Configuration/GetEALData",
                    type: "GET",
                    data: { RiskAreType: 'CDR', SurveyCategoryID: AmlCaViewModel.SelectedSurveyCategoryDetails().SurveyCategoryId().toString(), AssessmentTypes: AssessmentIdList, ScreenType: 'CDR' },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);



            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: InitiateAreaLevelTree() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {

                $('#loadingImgMainTab').hide();
                $('#MainTabDivCRSWIA').show();
                $('#RiskLevelTab').show();
                $('#NoDataDiv').hide();
                //$('#loadingImgMain').hide();
                if (jsonResult != null) {
                    //implement js tree logic here
                    AmlCaViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevel').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });

                    var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                    AmlCaViewModel.hasChildNodes(hasChildNodes);

                    //for initial load expand for treeview
                    $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                }
                $('#ControlsContent').hide();
            }
            function nodeClickEvent(event, node) {
                // Your logic goes here
                if (node.dead_node == 1) {

                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                    $('#loadingImgMain').show();

                    AmlCaViewModel.CurrentRiskAreaTypeList(node.assessmentTypeList());
                    AmlCaViewModel.SelectedRiskAreaId(parseInt(node.id));
                    AmlCaViewModel.SelectedRiskAreaName(node.text);
                    GetControlQuestionsNLevel(parseInt(node.id));


                } else {
                    //recursively opening until the dead_node arrives.
                    if (!(node.state.expanded))
                        nodeClickEvent(event, node.nodes[0]);
                    $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                    $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);


                }
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, {
                            buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                        })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            };

        }

        function ShowFilterDiv() {
            $("#FilterAreaAccordion").show();

            $("#btnShowFilterDiv").hide();
            $("#FilterAreaAccordion").addClass("col-lg-3");
            $("#FilterAreaAccordion").addClass("col-md-3");
            $("#FilterAreaAccordion").addClass("col-sm-3");
            $("#FilterAreaAccordion").addClass("col-xs-3");

            $("#bottomDivAreaType").removeClass("col-lg-12");
            $("#bottomDivAreaType").addClass("col-lg-9");
            $("#bottomDivAreaType").removeClass("col-md-12");
            $("#bottomDivAreaType").addClass("col-md-9");
            $("#bottomDivAreaType").removeClass("col-sm-12");
            $("#bottomDivAreaType").addClass("col-sm-9");
            $("#bottomDivAreaType").removeClass("col-xs-12");
            $("#bottomDivAreaType").addClass("col-xs-9");

        }

        function HideFilterDiv() {
            $("#FilterAreaAccordion").hide();

            $("#FilterAreaAccordion").removeClass("col-lg-3");
            $("#FilterAreaAccordion").removeClass("col-md-3");
            $("#FilterAreaAccordion").removeClass("col-sm-3");
            $("#FilterAreaAccordion").removeClass("col-xs-3");

            $("#btnShowFilterDiv").show();

            $("#bottomDivAreaType").removeClass("col-lg-9");
            $("#bottomDivAreaType").addClass("col-lg-12");
            $("#bottomDivAreaType").removeClass("col-md-9");
            $("#bottomDivAreaType").addClass("col-md-12");
            $("#bottomDivAreaType").removeClass("col-sm-9");
            $("#bottomDivAreaType").addClass("col-sm-12");
            $("#bottomDivAreaType").removeClass("col-xs-9");
            $("#bottomDivAreaType").addClass("col-xs-12");
        }

        function SurveyCategoryTabClick(data, event) {
            try {
                $('#loadingImgMain').show();
                $('#AssessmentUl li').removeClass('active');
                AmlCaViewModel.ClickedAssessmentTypeId(parseInt(event.currentTarget.id));

                for (var k = 0; k < AmlCaViewModel.SurveyCategoryList().length; k++) {
                    if (AmlCaViewModel.SurveyCategoryList()[k].SurveyCategoryId() === parseInt(event.currentTarget.id)) {

                        AmlCaViewModel.SelectedSurveyCategoryDetails(AmlCaViewModel.SurveyCategoryList()[k]);
                        $('#' + (event.currentTarget.id)).addClass('active');
                    }
                }
                $('#RiskLevelTab').tabs();
                scrollableTabs();
                $('#RiskLevelTab').tabs('refresh');

                $('#RiskLevelTab').tabs({ active: 0 });
                GetControlAreas();
                GetAllAssessmentTypes();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in InherentSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetControlAreas() {
            try {
                $.ajax({
                    url: "/api/ControlArea/GetAllControlAreaAndSubAreas",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "ParentUID": null,
                        "SurveyCategoryID": AmlCaViewModel.SelectedSurveyCategoryDetails().SurveyCategoryId(),
                        "AssessmentTypes": AmlCaViewModel.SelectedSurveyCategoryDetails().AssessmentTypeId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetControlAreas() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#loadingImgMainTab').hide();
                    $('#MainTabDivCRSWIA').show();
                    $('#RiskLevelTab').show();
                    $('#NoDataDiv').hide();
                    if (jsonResult != null && jsonResult.ControlAreaModel.length > 0) {


                        var MappedControlSubArea = $.map(jsonResult.ControlSubAreaModel, function (result) {
                            return new ControlAreaModel(result);
                        });
                        AmlCaViewModel.ControlSubAreaExhaustiveList([]);
                        AmlCaViewModel.ControlSubAreaExhaustiveList(MappedControlSubArea);

                    }
                    else if (jsonResult.length === 0 || jsonResult.length === undefined) {
                        $('#NoDataDiv').show();
                        $('#RiskLevelTab').hide();
                        $('#loadingImgMain').hide();
                        $("#ControlsContent").hide();
                        logger.logError('No Control Areas have been configured.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while fetching Control Areas.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetControlAreas() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetControlAreas() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetControlAreas() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function ConfigureInstructions() {

            AmlCaViewModel.Instructions('');
            GetInstructions().then(function () {


                //if (CKEDITOR.instances['Instructions']) {
                //    CKEDITOR.instances['Instructions'].destroy();
                //}
                //CKEDITOR.replace('Instructions',
                //    { removePlugins: 'elementspath' });
                $('#frmConfigureInstructions').modal('show');
            });
        }
        function GetInstructions() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getAllInstructions = {

                    url: "/api/Configuration/GetInstructions",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({
                        "AreaId": AmlCaViewModel.SelectedRiskAreaId(),
                        "AreaType": "CDR",
                        "Type": "SB"
                    }),
                    headers: headers
                };
                return $.ajax(getAllInstructions)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetInstructions() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult !== null) {
                    AmlCaViewModel.Instructions('');
                    AmlCaViewModel.Instructions(jsonResult.Instruction);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name))
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetInstructions method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetInstructions method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }
        function SaveInstructions() {
            try {
                //AmlCaViewModel.Instructions(CKEDITOR.instances["Instructions"].getData());
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SaveInstructions",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({
                        "AreaId": AmlCaViewModel.SelectedRiskAreaId(),
                        "AreaType": "CDR",
                        "Type": "SB",
                        "Instruction": AmlCaViewModel.Instructions()
                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveInstructions() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else {
                        $('#frmConfigureInstructions').modal('hide');
                        //CKEDITOR.instances["Instructions"].destroy();
                        //delete CKEDITOR.instances['Instructions'];
                        logger.logSuccess('Instructions are saved successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                        GetInstructions();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveInstructions() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    $('#frmConfigureInstructions').modal('hide');
                    //CKEDITOR.instances["Instructions"].destroy();
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveInstructions() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SaveInstructions() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function AssessmentTypeClick(data, event) {
            try {
                AmlCaViewModel.ClickedAssessmentTypeId(parseInt(event.currentTarget.id));

                $('#RiskLevelTab').tabs();
                scrollableTabs();
                $('#RiskLevelTab').tabs('refresh');

                $('#RiskLevelTab').tabs({ active: 0 });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentTypeClick() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function RATActionChanged(data, event) {
            try {
                var selectedassessmentsType = [];
                selectedassessmentsType = AmlCaViewModel.SelectedAssessmentType();
                AmlCaViewModel.ZATDropDownList([]);
                var MappedList = [];
                for (var j = 0; j < selectedassessmentsType.length; j++) {
                    for (var i = 0; i < AmlCaViewModel.ZATRATList().length; i++) {
                        if (selectedassessmentsType[j] === AmlCaViewModel.ZATRATList()[i].RAT_UID() &&
                            AmlCaViewModel.SelectedSurveyCategoryDetails().SurveyCategoryId() != AmlCaViewModel.ZATRATList()[i].ZAT_UID()) {
                            if (MappedList.length === 0)
                                MappedList.push(new ZATRATModel(AmlCaViewModel.ZATRATList()[i].ZAT_UID(), AmlCaViewModel.ZATRATList()[i].ZATName(), AmlCaViewModel.ZATRATList()[i].RAT_UID()));
                            else {
                                var countvar = 0;
                                for (var k = 0; k < MappedList.length; k++) {
                                    if (MappedList[k].ZAT_UID() === AmlCaViewModel.ZATRATList()[i].ZAT_UID()) {
                                        countvar++;
                                    }
                                }
                                if (countvar === 0)
                                    MappedList.push(new ZATRATModel(AmlCaViewModel.ZATRATList()[i].ZAT_UID(), AmlCaViewModel.ZATRATList()[i].ZATName(), AmlCaViewModel.ZATRATList()[i].RAT_UID()));
                            }
                        }
                    }
                }
                AmlCaViewModel.ZATDropDownList(MappedList);
                $('#ZATApplicability').multiselect();
                $('#ZATApplicability').multiselect('refresh');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RATActionChanged() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        //Function to bind the survey categories Dropdown Dynamically starts here
        function GetAllSurveyCategories() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                $.ajax({
                    url: "/api/Configuration/GetAllSurveyCategories",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null && jsonResult.length > 0) {
                            AmlCaViewModel.ZATRATList([]);
                            for (var i = 0; i < jsonResult.length; i++) {

                                var splitID = $.map(jsonResult[i].AssessmentTypeId.split(","), $.trim);
                                for (var j = 0; j < splitID.length; j++) {
                                    AmlCaViewModel.ZATRATList().push(new ZATRATModel(jsonResult[i].SurveyCategoryId, jsonResult[i].SurveyCategoryName, splitID[j], jsonResult[i].SurveyGroupShortName));
                                }

                            }
                            AmlCaViewModel.ZATRATListDup(AmlCaViewModel.ZATRATList());
                        }
                        else {
                            $('#loadingImgMainTab').hide();
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Survey Comoponents Details. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

        }
        //Function to bind the survey categories Dropdown ends here

        function GetConfigurationFreezeStatusByScreen() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetConfigurationFreezeStatusByScreen",
                    type: "GET",
                    data: { "CurrentScreenName": AmlCaViewModel.CurrentScreenName() },
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from GetConfigurationFreezeStatusByScreen() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (appsecurity.WriteAccess())
                        jsonResult ? AmlCaViewModel.ControlsAccess(false) : AmlCaViewModel.ControlsAccess(true);
                }
                else
                    logger.logError('An error occurred while fetching Configuration Freeze Status. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
            }

            function ajaxFail(error, status) {

                if (error.status == 401) {
                    app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetConfigurationFreezeStatusByScreen() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function FreezeConfigurationsByScreen() {
            app.showMessage('Are you sure you want to freeze the configurations? Once frozen, settings cannot be updated.', 'Freeze Configuration Settings', ['Freeze', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-plus text-default' })
                .then(function (option) {
                    if (option === 'Freeze') {
                        SetConfigurationFreezeByScreen();
                    }
                });
        }

        function SetConfigurationFreezeByScreen() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SetConfigurationFreezeByScreen",
                    headers: headers,
                    type: "POST",
                    data: { Status: 1, CurrentScreenName: AmlCaViewModel.CurrentScreenName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from SetConfigurationFreeze() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + " - An error occurred. Please contact your Application Administrator.", 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else if (jsonResult == "1") {
                        AmlCaViewModel.ControlsAccess(false);
                        logger.logSuccess('Configurations are frozen successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                        location.reload(true);
                    }
                    else if (jsonResult == "0") {
                        AmlCaViewModel.ControlsAccess(true);
                        logger.logError('An error occurred while freezing Configurations. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while freezing Configurations. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SetConfigurationFreezeByScreen() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetConfigurationFreezeByScreen() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from SetConfigurationFreezeByScreen() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }




        function SaveQuestionResponseSubLevel(data) {
            try {
                var ResponseValues = "";
                $('#valErrorSubResponseLocal').hide();
                if (AmlCaViewModel.ControlResponseLocalPopupType() == 'Add') {
                    if (data.Response == "") {
                        $('#valErrorSubResponseLocal').text("Please enter Response Option");
                        $('#valErrorSubResponseLocal').show();
                        return false;
                    }
                    if (AmlCaViewModel.SelectedResponseValues().length == 0) {
                        $('#valErrorSubResponseLocal').text("Please select Response Type");
                        $('#valErrorSubResponseLocal').show();
                        return false;
                    }
                    for (var i = 0; i < AmlCaViewModel.SelectedResponseValues().length; i++) {
                        if (i == 0)
                            ResponseValues += AmlCaViewModel.SelectedResponseValues()[i];
                        else
                            ResponseValues += "|" + AmlCaViewModel.SelectedResponseValues()[i];
                    }

                }
                else {
                    if (data.Response == "") {
                        $('#valErrorSubResponseLocal').text("Please enter Response Option");
                        $('#valErrorSubResponseLocal').show();
                        return false;
                    }
                    ResponseValues = data.ResponseParentID;
                }

                var applicability;
                if (data.CalculationApplicability)
                    applicability = 1;
                else
                    applicability = 0;
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/AddUpdateResponseForQuestion?copyOverResponse=" + AmlCaViewModel.copyOverResponse() + "&ScenarioId=" + parseInt(AmlCaViewModel.SelectedScenarioId()),
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({ Id: data.ResponseId, Response: data.Response, Score: data.Score, CalculationApplicability: applicability, ControlQuestionId: AmlCaViewModel.SelectedResponseRow()[1].ControlQuestionId(), ResponseParentID: ResponseValues, Sort_Order: parseInt(data.Sort_Order) })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveQuestionResponseSubLevel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#frmControlSubResponseLocal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (jsonResult != null & jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult[0].Incident_Description + " - An error occurred. Please contact your Application Administrator.", 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult == "1" ) {

                        GetQuestionResponse(data).then(function () {
                            ResposneTable(AmlCaViewModel.SelectedResponseRow());
                        })
                        logger.logSuccess('Control Response Options details added successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while adding Control Response Options.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveQuestionResponseSubLevel() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    $('#frmControlSubResponseLocal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQuestionResponseSubLevel() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SaveQuestionResponseSubLevel() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }
        function ControlArea(item) {
            try {
                var self = this;
                self.ControlAreaName = $('#controlareaname' + item).val();
                self.ControlDescription = $('#controlareadescription' + item).val();
                self.ControlAreaNotes = $('#EditRaTextArea' + item).val();
                self.LanguageType = item;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlArea() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetLanguages() {
            AmlCaViewModel.ObjGeneralSettings.getLanguages();
            AmlCaViewModel.LanguageList = AmlCaViewModel.ObjGeneralSettings.LanguageList();
            if (AmlCaViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                AmlCaViewModel.LanguageList.splice(0, 1);
            }
        }
        function ResponseLevelLanguageAdded() {
            try {

                var selectedLanguage = AmlCaViewModel.SelectedLanguageForResponseLevel();
                $('#DynamicResponseLevelNameDiv').empty();
                var ResponseLevelHTML = ""
                for (var j = 0; j < AmlCaViewModel.SelectedLanguageForResponseLevel().length; j++) {
                    for (var i = 0; i < AmlCaViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                        if (parseInt(AmlCaViewModel.SelectedLanguageForResponseLevel()[j]) == AmlCaViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID()) {

                            ResponseLevelHTML += '<div class="form-group d-flex nd-flex">' +
                                '<label class="col-lg-2 control-label">Response Name (' + AmlCaViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                                '<div class="col-lg-10">' +
                                '<input id="responseLevelName' + AmlCaViewModel.SelectedLanguageForResponseLevel()[j] + '" class="form-control" placeholder="Response Name in ' + AmlCaViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" data-bind="value: ControlResponseSubSubList().Response" type="text" />' +
                                '</div>' +
                                '</div>';

                        }
                    }
                }
                if (ResponseLevelHTML != "") {
                    $("#frmControlSubResponseScroll").css({ "height": "auto", "max-height": "auto", "overflow-y": "auto", "overflow-x": "hidden" });
                    $("modalContent").css({ "height": "auto", "max-height": "auto" });
                }
                else
                    $('#frmControlSubResponseScroll').removeAttr("style");

                document.getElementById('DynamicResponseLevelNameDiv').innerHTML = ResponseLevelHTML;
                ko.cleanNode(document.getElementById('DynamicResponseLevelNameDiv'));
                ko.applyBindings(AmlCaViewModel, document.getElementById("DynamicResponseLevelNameDiv"));

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseLevelLanguageAdded() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        // Control Area Language change event

        //----------------------------------------------------Logic to Handle Control Area Ends Here-----------------------------------------------------------------------------------


        //--------------------Control Sub Area Language change logic ends here-----------------------------------------------------------------------------------------------


        //----------------------------------------------------Logic to configure responses Starts here

        function GetConfiguredControlResponseData() {
            try {
                return $.ajax({
                    url: "/api/ControlArea/GetConfiguredControlResponseData",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetConfiguredControlResponseData() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length == 0) {
                            ResponseAddButton();
                        }
                        else {
                            var mappedresponsesList = $.map(jsonResult, function (result) {
                                return new ResponseDataModel(result);
                            });
                            AmlCaViewModel.ControlResponseList([]);
                            AmlCaViewModel.ControlResponseList(mappedresponsesList);
                            AmlCaViewModel.ControlResponseListDup(mappedresponsesList);
                            $('#frmResponsesmodel').modal('show');
                        }

                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetConfiguredControlResponseData() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetConfiguredControlResponseData() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetConfiguredControlResponseData() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function ResponseAddButton() {
            try {
                var newResponseModelObj;
                if (ResponsesValidate()) {
                    if (AmlCaViewModel.ControlResponseList().length >= 5) {
                        $('#rspError1').text("You cannot add more than 5 types of Responses");
                        $('#rspError1').show();
                    }
                    else if (AmlCaViewModel.ControlResponseList().length != 0) {

                        AmlCaViewModel.AddNewLevelCount(AmlCaViewModel.AddNewLevelCount() + 9999);
                        if (AmlCaViewModel.ControlResponseList().length == 0) {
                            newResponseModelObj = new ResponseDataModel({
                                Id: 0, Score: 0, Response: "", Flag: 'NEW', CalculationApplicability: 0
                            });
                        }
                        else {

                            newResponseModelObj = new ResponseDataModel({
                                Id: AmlCaViewModel.AddNewLevelCount(), Score: 0, Response: "", Flag: 'NEW', CalculationApplicability: 0
                            });

                            AmlCaViewModel.ControlResponseList.push(newResponseModelObj);
                            if (AmlCaViewModel.ControlResponseList().length == 1) {
                                AmlCaViewModel.ControlResponseListDup.push(newResponseModelObj);
                            }
                        }

                    }
                    else {
                        AmlCaViewModel.AddNewLevelCount(AmlCaViewModel.AddNewLevelCount() + 9999);
                        if (AmlCaViewModel.ControlResponseList().length == 0) {
                            newResponseModelObj = new ResponseDataModel({
                                Id: 0, Score: 0, Response: "", Flag: 'NEW', CalculationApplicability: 0
                            });
                        }
                        else {

                            newResponseModelObj = new ResponseDataModel({
                                Id: AmlCaViewModel.AddNewLevelCount(), Score: 0, Response: "", Flag: 'NEW', CalculationApplicability: 0
                            });

                        }
                        AmlCaViewModel.ControlResponseList.push(newResponseModelObj);
                        if (AmlCaViewModel.ControlResponseList().length == 1) {
                            AmlCaViewModel.ControlResponseListDup.push(newResponseModelObj);
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseAddButton() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ResponsesValidate() {
            try {
                var ValidationResult = 0;
                var CalAppValidation = 0;
                var ResponseData = AmlCaViewModel.ControlResponseList();
                for (var a = 0; a < ResponseData.length; a++) {
                    if (AmlCaViewModel.ControlResponseList()[a].CalculationApplicability()) {
                        CalAppValidation++;
                    }
                }
                for (var i = 0, j = ResponseData.length; i < j; i++) {
                    var DescValidation = 0;

                    for (var x = 0; x < i; x++) {
                        if (AmlCaViewModel.ControlResponseList()[x].Response() == AmlCaViewModel.ControlResponseList()[i].Response()) {
                            DescValidation++;
                        }
                    }
                    if (!ResponseData[i].CalculationApplicability()) {
                        if (ResponseData[i].Score().length == 0) {

                            $('#rspError2').text("The value of Score can not be left blank.");
                            $('#rspError2').show();
                            ValidationResult++;
                        }
                        else if (ResponseData[i].Score() < 0 || ResponseData[i].Score() > 1) {
                            $('#rspError2').text("Score should be between 0 to 1");
                            $('#rspError2').show();

                            ValidationResult++;
                        }
                        else if (isNaN(ResponseData[i].Score())) {
                            $('#rspError2').text("The value of Score should be a number.");
                            $('#rspError2').show();
                            ValidationResult++;
                        }
                    }
                    else if (CalAppValidation > 1) {
                        $('#rspError2').text("Only one Response can not be a part of Calculations");
                        $('#rspError2').show();

                        ValidationResult++;
                    }
                    else if (DescValidation > 0) {
                        $('#rspError2').text("Response cannot be a duplicate.");
                        $('#rspError2').show();

                        ValidationResult++;
                    }
                    else if (ResponseData[i].Response() == "") {
                        $('#rspError2').text("Response cannot be left blank.");
                        $('#rspError2').show();

                        ValidationResult++;
                    }
                    else {
                        $('#rspError2').hide();
                        $('#rspError1').hide();
                    }
                }
                if (ValidationResult > 0)
                    return false;
                else
                    return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponsesValidate() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ResponseDataModel(item) {
            try {

                var self = this;

                self.Response = ko.observable($('<div/>').html(item.Response).text());

                self.Id = ko.observable(item.Id);
                self.CalculationApplicability = ko.observable(item.CalculationApplicability);
                self.ratingApplicability = ko.observable(item.ratingApplicability);
                if (item.ratingApplicability) {
                    AmlCaViewModel.ratingApplicability(true);
                }
                else {
                    AmlCaViewModel.ratingApplicability(false);
                }
                if (item.CalculationApplicability) {
                    self.Score = ko.observable(item.Score);
                    self.CalculationApplicability = ko.observable(1);
                }
                else {
                    self.Score = ko.observable(item.Score);
                    self.CalculationApplicability = ko.observable(0);
                }
                if (AmlCaViewModel.AddNewLevelCount() == -1) {
                    self.Flag = ko.observable('');
                }
                else {
                    self.Flag = ko.observable(item.Flag);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseDataModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ResponseConditionalDataModel(item) {
            try {
                var self = this;
                self.Response = item.Response;
                self.ResponseId = item.Id;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseConditionalDataModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ResponseForQuestionModel(item) {
            try {
                var self = this;
                self.Response = item.Response;
                self.ResponseId = item.Id;
                self.ResponseParentID = item.ResponseParentID;
                self.ResponseParentName = item.ResponseParentName;
                self.Score = item.Score;
                self.CalculationApplicability = item.CalculationApplicability;
                self.Sort_Order = item.Sort_Order;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseConditionalDataModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function SaveResponses() {
            try {
                $('#rspError1').hide();
                $('#rspError2').hide();
                if (ResponsesValidate()) {
                    SaveControlResponseDetails();
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveResponses() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function SaveControlResponseDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                if (AmlCaViewModel.ratingApplicability()) {
                    AmlCaViewModel.ControlResponseList()[0].ratingApplicability(1);
                }
                else {
                    AmlCaViewModel.ControlResponseList()[0].ratingApplicability(0);
                }
                for (var i = 0; i < AmlCaViewModel.ControlResponseList().length; i++) {
                    if (AmlCaViewModel.ControlResponseList()[i].CalculationApplicability()) {
                        AmlCaViewModel.ControlResponseList()[i].CalculationApplicability(1);
                    }
                    else {
                        AmlCaViewModel.ControlResponseList()[i].CalculationApplicability(0);
                    }
                }
                var ResponseDataObj = $.map(AmlCaViewModel.ControlResponseList(), function (item) {

                    return {
                        Id: item.Id(), Response: item.Response(), Score: item.Score(), ratingApplicability: item.ratingApplicability(), CalculationApplicability: item.CalculationApplicability()
                    }
                })

                $.ajax({
                    url: "/api/ControlArea/SaveControlResponseDetails",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(ResponseDataObj)
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveControlResponseDetails() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                            logger.logError(jsonResult[0].ErrorCode + " - An error occurred. Please contact your Application Administrator.", 'Error', system.getModuleId(AmlCaViewModel), true);
                        }
                        else if (jsonResult.length != 0) {
                            $('#frmResponsesmodel').modal('hide');
                            $('#modalContent').css({
                                'margin-top': 'auto'
                            });
                            logger.logSuccess('Response types saved successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveControlResponseDetails() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveControlResponseDetails() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SaveControlResponseDetails() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }

            }
        };

        function DeleteResponses(data) {
            try {

                if (AmlCaViewModel.ControlResponseList().length > 1) {
                    app.showMessage('Are you sure you want to Delete this Response?' + "<br/><br/><b>" + ' Note : Please save the changes after delete' + "</b>", 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                        .then(function (option) {
                            if (option === 'Confirm') {

                                AmlCaViewModel.ControlResponseList.remove(data);
                            }
                        });
                    setTimeout(function () {
                        document.getElementById(event.target.id).focus();
                    }, 1);
                    event.preventDefault;
                    event.stopImmediatePropagation;
                    event.stopPropagation;
                    return false;

                }
                else {
                    app.showMessage("Delete operation has been terminated. There should be atleast one control rating.", "Delete operation terminated", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, {
                        buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                    })
                        .then(function (option) {
                            if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()) { }
                        })

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteResponses() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

        }

        function CloseModel(model_id) {
            $(model_id).modal('hide');
        }

        function CancelResponses() {
            try {
                AmlCaViewModel.isGlobalFlag(AmlCaViewModel.isGlobalFlagCopy());
                var mappedDupList = $.map(AmlCaViewModel.ControlResponseListDup(), function (item) {
                    return new ResponseDataModel({ Id: item.Id(), Response: item.Response(), Score: item.Score(), ratingApplicability: item.ratingApplicability(), CalculationApplicability: item.CalculationApplicability });
                })
                AmlCaViewModel.ControlResponseList(mappedDupList);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CancelResponses() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        //----------------------------------------------------Logic to configure responses Ends here

        function truncate(str) {
            str.area_name_truncated = str.area_name.split(" ").splice(0, 2).join(" ");
            if (str.area_name_truncated === str.area_name)
                str.area_name_truncated = str.area_name;
            else
                str.area_name_truncated += '...';
            return str;
        }

        function GetControlQuestionsNLevel(controlAreaId) {
            try {

                $.ajax({
                    url: "/api/ControlArea/GetAllControlQuestion",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        ControlAreaId: controlAreaId, ZatUid: AmlCaViewModel.ClickedAssessmentTypeId(),
                        AssessmentTypes: AmlCaViewModel.SelectedSurveyCategoryDetails().AssessmentTypeId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetControlQuestions() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#loadingImgMain').hide();
                    $('#QuestionsDiv').show();
                    $("#ControlsContent").show();
                    if (jsonResult != null && jsonResult.lstAreaLevelModel.length > 0) {

                        var MappedControlQuestion = $.map(jsonResult.lstQuestionModel, function (result) {
                            return new ControlQuestionModel(result);
                        })

                        var new_array = jsonResult.lstAreaLevelModel.map(function truncate(str) {
                            str.area_name_truncated = str.area_name.split(" ").splice(0, 5).join(" ");
                            if (str.area_name_truncated === str.area_name)
                                str.area_name_truncated = str.area_name;
                            else
                                str.area_name_truncated += '...';
                            return str;
                        });
                        AmlCaViewModel.BreadCrumbArray(new_array);

                        GetControlQuestionSortOrderNLevel(controlAreaId);
                        tableObj = $('#tblQuestions').DataTable();
                        tableObj.destroy();
                        $("#tblQuestions tbody tr").remove();
                        AmlCaViewModel.ControlQuestionList(MappedControlQuestion);
                        AmlCaViewModel.ControlQuestionListAsPerAssessmentType([]);
                        var i, j;

                        AmlCaViewModel.ControlQuestionListAsPerAssessmentType(MappedControlQuestion);
                        QuestionTablObj = $('#tblQuestions').DataTable({

                            "order": [],
                            "aaSorting": [],
                            "bResponsive": true,
                            "stateSave": true,
                            "aoColumnDefs": [{
                                "aTargets": [1],
                                "order": [],
                                "aaSorting": [],
                                "bVisible": false
                            },
                            {
                                "aTargets": [3],
                                "bSortable": false,
                                "order": [],
                                "aaSorting": []

                            },
                            {
                                "aTargets": [4],
                                "bSortable": false,
                                "order": [],
                                "aaSorting": []

                            },
                            {
                                "aTargets": [5],
                                "bSortable": false,
                                "order": [],
                                "aaSorting": [],
                                //   "sClass": "text-center",
                                "bVisible": (AmlCaViewModel.ControlsAccess()) ? true : false
                            }]
                        });
                        var rows = $("#tblQuestions").dataTable().fnGetNodes();
                        for (var i = 0; i < rows.length; i++) {
                            var x = $(rows[i]).find("td:eq(2)").html();
                            var y = x.replace(/}/g, '<br/>');
                            $(rows[i]).find("td:eq(2)").html(y);

                            var v = $(rows[i]).find("td:eq(2)").html();
                            var w = '';
                            var splited = v.split('{ ');
                            for (var m = 0; m < splited.length; m++) {
                                splited[m] = splited[m].replace('&lt;b&gt;', '<b>');
                                splited[m] = splited[m].replace('&lt;/b&gt;', '</b>');
                                if (m != splited.length - 1)
                                    w += splited[m] + '<br/>';
                                else
                                    w += splited[m];
                            }
                            $(rows[i]).find("td:eq(2)").html(w);
                            var p = $(rows[i]).find("td:eq(4)").html();
                            var q = '';
                            splited = p.split('|');
                            for (var m = 0; m < splited.length; m++) {
                                if (m != splited.length - 1)
                                    q += splited[m] + ', ';
                                else
                                    q += splited[m];
                            }
                            $(rows[i]).find("td:eq(4)").html(q);
                        }

                    }
                    else if (jsonResult.lstQuestionModel.length == 0) {

                        AmlCaViewModel.BreadCrumbArray(jsonResult.lstAreaLevelModel);
                        AmlCaViewModel.RiskQuestionReorderList([]);
                        AmlCaViewModel.RiskQuestionReorderListDup([]);
                        $("#ControlsContent").hide();
                        $('#loadingImgMain').hide();

                        logger.logError('No Control Questions have been configured.', 'Error', system.getModuleId(AmlCaViewModel), true);
                        tableObj = $('#tblQuestions').DataTable();
                        tableObj.destroy();
                        $("#tblQuestions tbody tr").remove();
                        QuestionTablObj = $('#tblQuestions').DataTable({
                            "bResponsive": true,
                            "stateSave": true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": false
                            },
                            {
                                "aTargets": [2],
                                "bSortable": false

                            },
                            {
                                "aTargets": [3],
                                "bSortable": false

                            },
                            {
                                "aTargets": [4],
                                "bSortable": false,
                                "bVisible": (AmlCaViewModel.ControlsAccess()) ? true : false
                            }]
                        });
                    }
                    else {
                        logger.logError('An error occurred while fetching Control Areas.', 'Error', system.getModuleId(AmlCaViewModel), true);
                        QuestionTablObj = $('#tblQuestions').DataTable();
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetControlQuestions() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetControlQuestions() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetControlQuestions() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DeleteLocalResponse(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/ControlArea/DeleteControlLocalResponse",
                    dataType: "json",
                    contentType: "application/json",
                    data: {
                        ResponseId: data.ResponseId
                    },
                    headers: headers,
                    type: "GET"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteLocalResponse() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (parseInt(jsonResult) > 0) {
                        logger.logSuccess('Control Response Options details deleted successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                        GetQuestionResponse(data).then(function () {
                            ResposneTable(AmlCaViewModel.SelectedResponseRow());
                        })
                    }

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteLocalResponse() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteLocalResponse() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteLocalResponse() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }




        function CheckExpandedRow2(row, isPaginating) {
            try {
                var currentRowIndex;
                var rowsInTable = $('#tblQuestions').find('tr');
                if (isPaginating)
                    currentRowIndex = -1;
                else
                    currentRowIndex = row.index();
                var info = QuestionTablObj.page.info();
                for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                    //if (currentRowIndex != (i - 1)) {
                    var tr = $('#tblQuestions').find('tr').get(i);
                    if (QuestionTablObj.row(tr).index() != currentRowIndex) {
                        var tableRowIndex = 0;
                        //if (isPaginating)
                        //    tableRowIndex = (AmlCaViewModel.CurrentPageNumber() * info.length) + (i - 1);
                        //else
                        tableRowIndex = (info.page * info.length) + (i - 1);
                        if ((QuestionTablObj.row(tableRowIndex).child() != undefined) && (QuestionTablObj.row(tableRowIndex).child.isShown())) {
                            QuestionTablObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown');
                            j = $('#tblQuestions').find('tr').length;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckExpandedRow2() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function RowExpandClick(data, event) {
            try {
                var tr = $(event.currentTarget).closest('tr');
                var row = QuestionTablObj.row(tr);
                AmlCaViewModel.SelectedResponseRow([]);
                AmlCaViewModel.SelectedResponseRow.push(tr);
                AmlCaViewModel.SelectedResponseRow.push(data);
                CheckExpandedRow2(row, false);
                if (row.child.isShown()) {
                    //close the open row
                    row.child.hide();
                    tr.removeClass('shown');
                    ResponseTableObj = false;
                }
                else {
                    // Open this row
                    GetQuestionResponse(data).then(function () {
                        ResposneTable(AmlCaViewModel.SelectedResponseRow());
                    })

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RowExpandClick() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ResposneTable(param) {
            var tr = param[0];
            var row = QuestionTablObj.row(tr);
            row.child("");
            row.child(format2(row.data())).show();
            tr.addClass('shown');
            ko.applyBindingsToNode($('#tblQuestionResponse tbody').get(0), { foreach: AmlCaViewModel.QuestionResponsesList() }, AmlCaViewModel);
            if (AmlCaViewModel.ControlsAccess() && !AmlCaViewModel.isGlobalFlag())
                ko.applyBindingsToNode($('#btnAddResponse').get(0), { click: AmlCaViewModel.AddResponsePopUp }, param[1]);
            ResponseTableObj = $('#tblQuestionResponse').DataTable({
                "bResponsive": true,
                "stateSave": true,
                "bPaginate": true,

                "aaSorting": [],
                "aoColumnDefs": [{
                    "aTargets": [0],
                    "bVisible": false
                }, {
                    "aTargets": [1],
                    "bSortable": true
                }, {
                    "aTargets": [5],
                    "bSortable": false,
                    "sClass": "text-center",
                    "bVisible": (AmlCaViewModel.ControlsAccess()) ? true : false
                }]
            })

        }
        function GetQuestionResponse(data) {
            try {
                var ControlQuestionId = AmlCaViewModel.SelectedResponseRow()[1].ControlQuestionId();
                return $.ajax({
                    url: "/api/Visualization/GetControlQuestionResponseWIA?ControlQuestionId=" + ControlQuestionId + "&ScenarioId=" + parseInt(AmlCaViewModel.SelectedScenarioId()),
                 //   url: "/api/ControlArea/GetControlQuestionResponse?ControlQuestionId=" + ControlQuestionId,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetQuestionResponse() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    AmlCaViewModel.QuestionResponsesList([]);
                    if (jsonResult != null && jsonResult.length > 0) {
                        AmlCaViewModel.QuestionResponsesList([]);
                        var MappedQuestionResponses = $.map(jsonResult, function (result) {
                            return new ResponseForQuestionModel(result);
                        })
                        AmlCaViewModel.QuestionResponsesList(MappedQuestionResponses);

                    }
                    else if (jsonResult == null)
                        logger.logError('An error occurred while fetching the responses for this question.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionResponse() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionResponse() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionResponse() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function format2(data) {
            try {
                var ResponseHtml = '<div class="child-active" style="margin-left:3em;">' +
                    '<div class="panel panel-success panel-margin">' +
                    '<div class="panel-heading">' +
                    '<h5 class="panel-title riskFactorCellPanel">Responses';
                if (AmlCaViewModel.ControlsAccess() && !AmlCaViewModel.isGlobalFlag()) {
                    ResponseHtml += '<button id="btnAddResponse" class="secondary-btn pull-right addSubFactorBtn" data-bind="click: $root.AddResponsePopUp" title="Click to Add New Response for the Question">' +
                        '<i class="fa fa-plus"></i> Add Responses' +
                        '</button>';
                }
                ResponseHtml += '</h5>' +
                    '</div>' +
                    '</div>' +
                    '<div class="subfactor-margin">' +
                    '<table id="tblQuestionResponse" class="dataTable table-bordered" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th style="display:none">Response ID</th>' +
                    '<th>';
                //Response Option
                ResponseHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseOption') == -1) ? 'Response Option' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseOption')].Name();
                ResponseHtml += '</th > ' +
                    '<th>';
                //Response Type
                ResponseHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseType') == -1) ? 'ResponseType' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseType')].Name();
                ResponseHtml += '</th > ' +
                    '<th>';
                ResponseHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskScore') == -1) ? 'Risk Score' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskScore')].Name();
                //Risk Score
                ResponseHtml += '</th > ' +
                    '<th>';
                ResponseHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability') == -1) ? 'Calculation Applicability' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability')].Name();
                //Calculation Applicability;
                ResponseHtml += '</th > ' +
                    '<th class="actions">';
                ResponseHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();
                //Actions
                ResponseHtml += '</th > ' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: QuestionResponsesList">' +
                    '<tr>' +
                    '<td style="display:none" data-bind="text: ResponseId"></td>' +
                    '<td data-bind="html: Response"></td>' +
                    '<td data-bind="html: ResponseParentName"></td>' +
                    '<td data-bind="text: Score"></td>' +
                    '<td data-bind="text: CalculationApplicability"></td>';
                if (!AmlCaViewModel.isGlobalFlag()) {
                    ResponseHtml +=
                        '<td class="text-center">' +
                        '<a href="javascript:void(0)" title="Edit Response" class="btn-borderless widget-button" data-bind="click: $root.EditResponsePopUp">' +
                        '<i class="demo-icon icon-file_edit_special"></i>' +
                        '</a>' +
                        '</td>';
                }
                else {
                    ResponseHtml +=
                        '<td class="text-center">' +

                        '</td>';
                }
                ResponseHtml += '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +
                    '<div>';
                return ResponseHtml;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: Format() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }


        function AddConditionalQuestionPopUp(data) {

            AmlCaViewModel.FactorConditionalType(true);
            AmlCaViewModel.QuestionGuideline('');
            AmlCaViewModel.ControlQuestionId(data.ControlQuestionId());
            AmlCaViewModel.ControlQuestionName(data.ControlQuestionName());
            AmlCaViewModel.ControlQuestionPop(new controlQuestionPopModel(data, 'Conditional'));

            if ((AmlCaViewModel.ControlResponselvlList().length > 0 && AmlCaViewModel.ControlResponselvlList()[0].Response() == "") || AmlCaViewModel.ControlResponselvlList().length == 0) {
                GetResponseLevels();
            }
            var mappedResponses = [];
            for (var j = 0; j < AmlCaViewModel.ControlResponselvlList().length; j++) {
                for (var i = 0; i < data.ControlResponseId().length; i++) {
                    if (data.ControlResponseId()[i] == parseInt(AmlCaViewModel.ControlResponselvlList()[j].Id())) {
                        mappedResponses.push(AmlCaViewModel.ControlResponselvlList()[j])
                    }
                }
            }
            AmlCaViewModel.ParentResposneAddSublevelList(mappedResponses);
            var mappedassessment = $.map(AmlCaViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < data.AssessmentIdList().length; i++) {
                    if (data.AssessmentIdList()[i] == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }
            });
            AmlCaViewModel.QuestionAssessmentTypeList(mappedassessment);
            GetAllSubResponsesForConditionalType(mappedResponses[0].Id());
            AmlCaViewModel.ControlQuestionPopUpTitle("Add New Conditional Question");
            $('#frmControlQuestion').modal('show');
            //CKEDITOR.replace('QuestionGuideline',
            //    {
            //        allowedContent: true,
            //        extraAllowedContent: '*(GuidelineCKEEditor)'

            //    });
            $('#QuestionApplicabilityDropdownedit').hide();
            $('#AlwaysVisibleDiv').show();
            $('#appQuestionRspAppedit').hide();
            $('#FactorAppTypeID').multiselect();
            $('#CopyOverAreasAppTypeID').multiselect();
            $('#ControlResponseTypes').multiselect();
            $('#ConAppTypeID').multiselect();
            $('#ControlResponseOptions').multiselect();
            $('#ControlResponseOptions').multiselect('refresh');
            $('#RAControlFactorLanguage').multiselect();
            $("#ControlQuestionScroll").removeAttr("Style");
        }

        function AddResponsePopUp(data, event) {
            try {
                $('#valErrorSubResponseLocal').text('');
                $('#valErrorSubResponseLocal').hide();
                AmlCaViewModel.SelectedResponseValues([]);
                AmlCaViewModel.copyOverResponse(false);
                AmlCaViewModel.ResponseValueListForQuestion([]);
                for (var i = 0; i < data.ControlResponseId().length; i++) {
                    for (var j = 0; j < AmlCaViewModel.ControlResponselvlList().length; j++) {
                        if (data.ControlResponseId()[i] == AmlCaViewModel.ControlResponselvlList()[j].Id()) {
                            //AmlCaViewModel.ResponseValueListForQuestion.push(AmlCaViewModel.ControlResponselvlList()[j])
                            for (var m = 0; m < data.ResponseOptionTypeList.length; m++) {
                                if (data.ResponseOptionTypeList[m].ResponseTypeId() == data.ControlResponseId()[i]
                                    && data.ResponseOptionTypeList[m].OptionTypeShortName() != 'R'
                                    && data.ResponseOptionTypeList[m].OptionTypeShortName() != 'T') {
                                    AmlCaViewModel.ResponseValueListForQuestion.push(AmlCaViewModel.ControlResponselvlList()[j])
                                    //return result;
                                }

                            }
                        }
                    }
                }//using here only response parent id to store the question id elsewhere used to store response value
                var NewModel = new ResponseForQuestionModel({ Id: '999', Score: 0, Response: "", CalculationApplicability: 0, ResponseParentId: data.ControlQuestionId(), Sort_Order: 1 })
                AmlCaViewModel.NewResponseLevelModel(NewModel);
                AmlCaViewModel.ControlResponseLocalPopupType('Add');
                AmlCaViewModel.ControlResponseLocalPopupTitle('Add Control Response level');
                $('#RaResponse').multiselect();
                $('#frmControlSubResponseLocal').modal('show');
                setTimeout("$('#frmControlSubResponseLocal').focus();", 500);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AddResponsePopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function EditResponsePopUp(data, event) {
            try {
                var ResponseParentName;
                for (var i = 0; i < AmlCaViewModel.ControlResponselvlList().length; i++) {
                    if (data.ResponseParentID == AmlCaViewModel.ControlResponselvlList()[i].Id()) {
                        ResponseParentName = AmlCaViewModel.ControlResponselvlList()[i].Response();
                    }
                }
                var NewModel = new ResponseForQuestionModel({ Id: data.ResponseId, Score: data.Score, Response: data.Response, CalculationApplicability: data.CalculationApplicability, ResponseParentID: data.ResponseParentID, ResponseParentName: ResponseParentName, Sort_Order: data.Sort_Order })
                AmlCaViewModel.NewResponseLevelModel(NewModel);
                AmlCaViewModel.ControlResponseLocalPopupType('Edit');
                AmlCaViewModel.ControlResponseLocalPopupTitle('Edit Control Response level');
                $('#frmControlSubResponseLocal').modal('show');
                setTimeout("$('#frmControlSubResponseLocal').focus();", 500);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditResponsePopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetControlQuestionSortOrder(data) {
            try {
                AmlCaViewModel.RiskQuestionReorderList([]);
                AmlCaViewModel.RiskQuestionReorderListDup([]);
                $.ajax({
                    url: "/api/ControlArea/GetControlQuestionSortOrder",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                    , data: {
                        ControlAreaId: data.ControlAreaId(), ZatUid: AmlCaViewModel.ClickedAssessmentTypeId(),
                        AssessmentTypes: AmlCaViewModel.SelectedSurveyCategoryDetails().AssessmentTypeId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, error) {
                try {
                    AmlCaViewModel.ControlQuestionSortOrder(0);
                    var MappedControlQuestionSortOrder = $.map(jsonResult, function (result) {
                        return new ControlQuestionSortModel(result);
                    })
                    AmlCaViewModel.ControlQuestionSortOrder(0);
                    var MappedControlQuestionSortOrderDup = $.map(jsonResult, function (result) {
                        return new ControlQuestionSortModel(result);
                    })

                    AmlCaViewModel.RiskQuestionReorderList(MappedControlQuestionSortOrder);
                    AmlCaViewModel.RiskQuestionReorderListDup(MappedControlQuestionSortOrderDup);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetControlQuestionSortOrderNLevel(controlAreaId) {
            try {
                AmlCaViewModel.RiskQuestionReorderList([]);
                AmlCaViewModel.RiskQuestionReorderListDup([]);
                $.ajax({
                    url: "/api/ControlArea/GetControlQuestionSortOrder",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                    , data: {
                        ControlAreaId: controlAreaId, ZatUid: AmlCaViewModel.ClickedAssessmentTypeId(),
                        AssessmentTypes: AmlCaViewModel.SelectedSurveyCategoryDetails().AssessmentTypeId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, error) {
                try {
                    AmlCaViewModel.ControlQuestionSortOrder(0);
                    var MappedControlQuestionSortOrder = $.map(jsonResult, function (result) {
                        return new ControlQuestionSortModel(result);
                    })
                    AmlCaViewModel.ControlQuestionSortOrder(0);
                    var MappedControlQuestionSortOrderDup = $.map(jsonResult, function (result) {
                        return new ControlQuestionSortModel(result);
                    })

                    AmlCaViewModel.RiskQuestionReorderList(MappedControlQuestionSortOrder);
                    AmlCaViewModel.RiskQuestionReorderListDup(MappedControlQuestionSortOrderDup);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetControlQuestionSortOrder() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }
        function AddControlQuestionPopUp(data, e) {//
            AmlCaViewModel.QuestionGuideline('');
            AmlCaViewModel.ControlQuestionPop(new controlQuestionPopModel(data, 'Control'));
            AmlCaViewModel.ControlQuestionType(true);
            AmlCaViewModel.AddConditionalQuestionType(false);
            AmlCaViewModel.ResponseOptionddFlag(false);
            AmlCaViewModel.LanguageCntrlFactorDdVisible(false);
            AmlCaViewModel.FactorConditionalType(false);
            AmlCaViewModel.GlobalResponses(false);
            AmlCaViewModel.ResponseOptionList([]);
            ;           // AmlCaViewModel.selectedOptionType();
            var mappedassessment;
            mappedassessment = $.map(AmlCaViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < AmlCaViewModel.CurrentRiskAreaTypeList().length; i++) {
                    if (AmlCaViewModel.CurrentRiskAreaTypeList()[i] == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }
            });
            if (AmlCaViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                AmlCaViewModel.ObjGeneralSettings.getLanguages();
            }
            AmlCaViewModel.LanguageList = AmlCaViewModel.ObjGeneralSettings.LanguageList();
            if (AmlCaViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                AmlCaViewModel.LanguageList.splice(0, 1);
            }
            if ((AmlCaViewModel.ControlResponselvlList().length > 0 && AmlCaViewModel.ControlResponselvlList()[0].Response() == "") || AmlCaViewModel.ControlResponselvlList().length == 0) {
                GetResponseLevels();
            }
            AmlCaViewModel.SelectedResponseOptionType([]),
                AmlCaViewModel.SelectedLanguageCntrlFactorType([]),
                AmlCaViewModel.SelectedAssessmentTypeQuestion([]),
                AmlCaViewModel.ControlLanguageFactorList([]),
                AmlCaViewModel.QuestionAssessmentTypeList(mappedassessment);
            var NewData = new ControlQuestionModel({ ControlQuestionId: 0, ControlQuestionName: "", OEQuestiondata: "", CDQuestiondata: "", NAQuestionData: "", ControlDesign: false, OperatingEffectiveness: false, NotApplicable: false, ControlLanguageFactorList: new LanguageFactorModel("", ""), ControlQuestionList: AmlCaViewModel.ControlQuestionList(), ResponseQuestionName: "" })
            AmlCaViewModel.ControlQuestionPopUpData(NewData);
            AmlCaViewModel.ControlQuestionPopUpTitle("Add New Control Question");
            AmlCaViewModel.ControlQuestionPopUpType("Add");
            AmlCaViewModel.ControlSaveDisabled(false);
            $('#frmControlQuestion').modal('show');
            //CKEDITOR.replace('QuestionGuideline',
            //    {
            //        allowedContent: true,
            //        extraAllowedContent: '*(GuidelineCKEEditor)'
            //    });
            $('#QuestionApplicabilityDropdownedit').hide();
            $('#AlwaysVisibleDiv').hide();
            $('#appQuestionRspAppedit').hide();
            $('#FactorAppTypeID').multiselect();
            $('#ControlResponseTypes').multiselect();
            $('#RAApplicability').multiselect();
            $('#ConAppTypeID').multiselect();
            $('#RAControlFactorLanguage').multiselect();
            $("#ControlQuestionScroll").removeAttr("Style");
            $('#CopyOverAreasAppTypeID').multiselect();
        }
        function controlQuestionPopModel(data, event) {
            var self = this;
            self.errorList = ko.observableArray();
            self.showErrorList = ko.observable(false);
            self.saveControlQuestion = function () {
                // AmlCaViewModel.QuestionGuideline(CKEDITOR.instances["QuestionGuideline"].getData());
                var errors = ko.validation.group(AmlCaViewModel.ControlQuestionPop(), { deep: true });
                self.errorList(errors());
                if (self.errorList().length > 0) {
                    self.showErrorList(true);
                    return;
                }
                else if (AmlCaViewModel.QuestionGuideline().length > 4000) {

                    self.errorList().push("Control Questions Guideline cannot exceed 4000 characters. Please enter a valid Guideline.");
                    self.showErrorList(true);
                    return;
                }
                else {
                    self.showErrorList(false);
                    self.selectedCopyOverAreas.push(AmlCaViewModel.SelectedRiskAreaId());
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        type: "POST",
                        url: "/api/ControlArea/ControlQuestionSave",
                        data: ko.toJSON({
                            languageModel: self.questionsList(),
                            QuestionType: self.questionSelected(),
                            //IsMultiselect: self.isMultiselect(),
                            Applicability: self.selectedApplicableAssessmentType().join('|'),
                            ApplicableArea: self.selectedCopyOverAreas().join('|'),
                            HeaderId: self.headerId(),
                            ZatId: AmlCaViewModel.ClickedAssessmentTypeId(),
                            CalculationApplicability: self.applicability(),
                            EcqParentResponseType: self.ResponseId(),
                            EcqParentID: self.EcqParentID(),
                            ResponseTypeOption: (self.selectedResponseOptions() != undefined || self.selectedResponseOptions() != null) ? self.selectedResponseOptions().join('|') : null,
                            EcqParentQuestion: self.EcqParentQuestion(),
                            VisibilityFlag: false,
                            IsGlobal: self.isGlobalQuestion(),
                            QuestionGuideline: AmlCaViewModel.QuestionGuideline(),
                            ResponseOptionTypeModelObject: AmlCaViewModel.ResponseOptionList()
                            //OptionTypeShortName: AmlCaViewModel.selectedOptionType()
                        }),
                        dataType: "json",
                        contentType: "application/json; charset=utf-8",
                        headers: headers,
                        success: function (result) {
                            if (result == 1) {
                                AmlCaViewModel.ControlQuestionName("");
                                GetControlQuestionsNLevel(AmlCaViewModel.SelectedRiskAreaId());

                                logger.logSuccess('Control Question details added  successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                                $('#frmControlQuestion').modal('hide');
                            }
                            else
                                logger.logError('An error occurred while adding Control Question details.', 'Error', system.getModuleId(AmlCaViewModel), true);
                        },
                        failure: function (error) {
                            logger.logError('An error occurred while adding Control Question details.', 'Error', system.getModuleId(AmlCaViewModel), true);
                        }
                    });
                }
            };

            self.isMultiselect = ko.observable(false);
            self.applicability = ko.observable(false);
            self.isGlobalQuestion = ko.observable(false);
            self.headerId = ko.observable();
            self.riskAreaDropDownList = ko.observableArray();
            self.questionSelected = ko.observable();
            self.questionsList = ko.observableArray();
            self.HeaderQuestions = ko.observableArray();
            self.HeaderQuestionsFiltered = ko.observableArray();
            self.selectedArea = ko.observable();
            self.EcqParentID = ko.observable();
            self.EcqParentQuestion = ko.observable();
            self.EcqParentResponseType = ko.observable();
            self.ResponseId = ko.observable();
            self.selectedCopyOverAreas = ko.observableArray();
            self.selectedLanguage = ko.observable();
            self.selectedResponseOptionType = ko.observable().extend({
                required: {
                    message: "Response Type is required.",
                    onlyIf: function () {
                        if (self.questionSelected() != 'H')
                            return true;
                        else
                            return false;
                    }
                }
            });
            self.selectedResponseOptions = ko.observable().extend({
                required: {
                    message: "Please select atleast one response options.",
                    onlyIf: function () {
                        if (event == 'Control')
                            return false;
                        else
                            return true;
                    }
                }
            });
            self.questionType = ko.observableArray();
            if (event == 'Control') {
                self.questionType([
                    { questionTypeName: 'Read Only Question', questionValue: 'R' },
                    { questionTypeName: 'Header Question', questionValue: 'H' }
                ]);
            }
            else {
                self.questionType([
                    { questionTypeName: 'Read Only Question', questionValue: 'CR' }
                ]);
            }
            self.questionSelected.subscribe(function (newVal) {
                $('#ControlResponseTypes').multiselect();
                self.showErrorList(false);
                if (newVal == 'H') {
                    self.riskAreaDropDownList([]);
                    self.questionsList([]);
                    //Default Short Question
                    var defaultShortQuestion = new ResponselevelModel({ Id: -99, Response: 'Short Question', ResponseQuestionVisble: true, Response_Ref_Id: -99 });
                    self.questionsList.push(defaultShortQuestion);
                    var defaultHeaderQuestion = new ResponselevelModel({ Id: 0, Response: 'Header Question', ResponseQuestionVisble: true });
                    self.questionsList.push(defaultHeaderQuestion);
                    for (var i = 0; i < AmlCaViewModel.LanguageList.length; i++) {
                        self.questionsList.push(new ResponselevelModel({ Id: -99, Response: 'Short Question', ResponseQuestionVisble: false, Response_Ref_Id: -99 }, AmlCaViewModel.LanguageList[i].LANGUAGE_ID(), AmlCaViewModel.LanguageList[i].LANGUAGENAME()));
                        self.questionsList.push(new ResponselevelModel({ Id: 0, Response: 'Header Question', ResponseQuestionVisble: false }, AmlCaViewModel.LanguageList[i].LANGUAGE_ID(), AmlCaViewModel.LanguageList[i].LANGUAGENAME()));
                    }
                }
                else {
                    self.questionsList([]);
                    //Default Short Question
                    var defaultShortQuestion = new ResponselevelModel({ Id: -99, Response: 'Short Question', ResponseQuestionVisble: false, Response_Ref_Id: -99 });
                    self.questionsList.push(defaultShortQuestion);
                    // Default

                    if (responseLevel != undefined) {
                        $.map(responseLevel, function (item) {
                            self.questionsList.push(new ResponselevelModel(item));
                        });

                        // Language related questions
                        for (var i = 0; i < AmlCaViewModel.LanguageList.length; i++) {
                            self.questionsList.push(new ResponselevelModel({ Id: -99, Response: 'Short Question', ResponseQuestionVisble: false, Response_Ref_Id: -99 }, AmlCaViewModel.LanguageList[i].LANGUAGE_ID(), AmlCaViewModel.LanguageList[i].LANGUAGENAME()));
                            $.map(responseLevel, function (item) {
                                self.questionsList.push(new ResponselevelModel(item, AmlCaViewModel.LanguageList[i].LANGUAGE_ID(), AmlCaViewModel.LanguageList[i].LANGUAGENAME()));
                            });
                        }
                    }
                    // Header Questions
                    self.HeaderQuestions([]);
                    for (var i = 0; i < AmlCaViewModel.ControlQuestionListAsPerAssessmentType().length; i++) {
                        if (AmlCaViewModel.ControlQuestionListAsPerAssessmentType()[i].QuestionTypeText() === 'Header')
                            self.HeaderQuestions.push(new ControlQuestionModel({ ControlQuestionId: AmlCaViewModel.ControlQuestionListAsPerAssessmentType()[i].ControlQuestionId(), ControlQuestionName: AmlCaViewModel.ControlQuestionListAsPerAssessmentType()[i].ControlQuestionName(), RISK_ASSESSMENT_ID: AmlCaViewModel.ControlQuestionListAsPerAssessmentType()[i].RiskAssesmentList(), CONTROL_AREA_ID: AmlCaViewModel.ControlQuestionListAsPerAssessmentType()[i].ControlAreaIDList() }));
                    }
                }
                $('#ControlResponseTypes').multiselect('destroy');
                $('#ControlResponseTypes').multiselect();
            });
            if (event == 'Control') {
                self.questionSelected('');
                self.selectedArea(AmlCaViewModel.SelectedRiskAreaName());
            }
            else {
                self.questionSelected('C');
                self.selectedArea(AmlCaViewModel.SelectedRiskAreaName());
                self.EcqParentID(AmlCaViewModel.ControlQuestionId());
                self.EcqParentQuestion(AmlCaViewModel.ControlQuestionName());
                self.ResponseId(((data.ControlResponseId() != null && data.ControlResponseId() != undefined) ? data.ControlResponseId().join('|') : data.ControlResponseId()));
            }
            self.resetRadioButtons = function () {
                if (event == 'Control') {
                    self.questionSelected('');
                }
                else
                    self.questionSelected('C');
            };
            self.selectedApplicableAssessmentType = ko.observable().extend({
                required: {
                    message: "Assessment type is required.",
                    onlyIf: function () {
                        return true;
                    }
                }
            });

            var controlSubAreas = AmlCaViewModel.ControlSubAreaExhaustiveList();
            self.selectedApplicableAssessmentType.subscribe(function (newVal) {
                self.riskAreaDropDownList([]);
                // To make all the selections unselected
                // To make all the selections unselected
                for (var k = 0; k < controlSubAreas.length; k++) {
                    controlSubAreas[k].controlAreaSelected(false);
                }
                for (var i = 0; i < newVal.length; i++) {
                    for (var l = 0; l < controlSubAreas.length; l++) {
                        for (var j = 0; j < controlSubAreas[l].MappedAssessmentType().length; j++) {
                            if ((controlSubAreas[l].ControlAreaName() != self.selectedArea()) && (parseInt(newVal[i]) == controlSubAreas[l].MappedAssessmentType()[j].ID) && (controlSubAreas[l].controlAreaSelected() != true)) {
                                controlSubAreas[l].controlAreaSelected(true);
                                self.riskAreaDropDownList.push(controlSubAreas[l]);
                            }
                        }
                    }
                }

                self.headerQuestionFilter();
                $('#CopyOverAreasAppTypeID').multiselect('destroy');
                $('#CopyOverAreasAppTypeID').multiselect({ buttonWidth: '100%' });
            });
            self.selectedCopyOverAreas.subscribe(function (newVal) {
                self.headerQuestionFilter();
            });
            self.selectedLanguage.subscribe(function (newVal) {
                // To make all the selections unselected
                for (var j = 0; j < self.questionsList().length; j++) {
                    if (self.questionsList()[j].langID() != 0) // To not hide default questions
                        self.questionsList()[j].ResponseQuestionVisble(false);
                }
                if (self.selectedResponseOptionType() && self.questionSelected() != 'H') {
                    for (var k = 0; k < self.selectedResponseOptionType().length; k++) {
                        for (var i = 0; i < newVal.length; i++) {
                            for (var j = 0; j < self.questionsList().length; j++) {
                                if (parseInt(self.questionsList()[j].langID()) == parseInt(newVal[i]) && ((parseInt(self.questionsList()[j].Response_Ref_Id()) == self.selectedResponseOptionType()[k]) || (parseInt(self.questionsList()[j].Response_Ref_Id()) == -99)))
                                    self.questionsList()[j].ResponseQuestionVisble(true);
                            }
                        }
                    }
                }
                else if (self.questionSelected() == 'H') {
                    for (var i = 0; i < newVal.length; i++) {
                        for (var j = 0; j < self.questionsList().length; j++) {
                            if (parseInt(self.questionsList()[j].langID()) == parseInt(newVal[i]))
                                self.questionsList()[j].ResponseQuestionVisble(true);
                        }
                    }
                }

            });
            self.selectedResponseOptionType.subscribe(function (newVal) {
                for (var j = 0; j < self.questionsList().length; j++) {
                    self.questionsList()[j].ResponseQuestionVisble(false);
                }
                for (var i = 0; i < newVal.length; i++) {
                    // Default Question
                    for (var j = 0; j < self.questionsList().length; j++) {
                        if (((parseInt(self.questionsList()[j].Response_Ref_Id()) == parseInt(newVal[i])) || parseInt(self.questionsList()[j].Response_Ref_Id()) == -99) && (self.questionsList()[j].langID() == 0))
                            self.questionsList()[j].ResponseQuestionVisble(true);
                    }
                    // Language selected Questions
                    if (self.selectedLanguage()) {
                        for (var k = 0; k < self.selectedLanguage().length; k++) {
                            for (var j = 0; j < self.questionsList().length; j++) {
                                if (((parseInt(self.questionsList()[j].Response_Ref_Id()) == parseInt(newVal[i])) || parseInt(self.questionsList()[j].Response_Ref_Id()) == -99) && (self.questionsList()[j].langID() == self.selectedLanguage()[k]))
                                    self.questionsList()[j].ResponseQuestionVisble(true);
                            }
                        }
                    }
                }
            });
            self.headerQuestionFilter = function () {
                var filteredList = ko.utils.arrayFilter(self.HeaderQuestions(), function (item) {
                    var includeHeaderQuestion = (self.selectedApplicableAssessmentType().length) > 0 ? true : false;
                    for (var i = 0; i < self.selectedApplicableAssessmentType().length; i++) {
                        if (!item.RiskAssesmentList().includes(self.selectedApplicableAssessmentType()[i])) {
                            includeHeaderQuestion = false;
                            break;
                        }
                    }
                    if (includeHeaderQuestion != false) {
                        for (var j = 0; j < self.selectedCopyOverAreas().length; j++) {
                            if (!item.ControlAreaIDList().includes(self.selectedCopyOverAreas()[j])) {
                                includeHeaderQuestion = false;
                                break;
                            }
                        }
                    }
                    return includeHeaderQuestion;
                });
                self.HeaderQuestionsFiltered(filteredList);
            };
        }
        //working here

        function CntrlFactorResponseSelected() {
            try {
                if (AmlCaViewModel.SelectedLanguageCntrlFactorType().length > 0) {
                    AmlCaViewModel.SelectedLanguageCntrlFactorType([]);
                }
                if (AmlCaViewModel.SelectedResponseOptionType().length > 0) {
                    RemoveHeaderTypeQuestion();
                    AmlCaViewModel.LanguageCntrlFactorDdVisible(true);
                    AmlCaViewModel.ControlQuestionType(true);
                    ko.cleanNode(document.getElementById('RAControlFactorLanguage'));
                    ko.applyBindings(AmlCaViewModel, document.getElementById("RAControlFactorLanguage"));
                    $('#RAControlFactorLanguage').multiselect();
                    AmlCaViewModel.ControlSaveDisabled(true);
                    $('#Dynamicquestion').empty();
                    var questionHTMl = "";

                    for (var j = 0; j < AmlCaViewModel.SelectedResponseOptionType().length; j++) {
                        for (var i = 0; i < AmlCaViewModel.ControlResponselvlList().length; i++) {
                            if (parseInt(AmlCaViewModel.SelectedResponseOptionType()[j]) == AmlCaViewModel.ControlResponselvlList()[i].Response_Ref_Id()) {

                                questionHTMl += '<div class="form-group">' +
                                    '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + AmlCaViewModel.ControlResponselvlList()[i].Response() + ' Question</label>' +
                                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                    '<textarea id="question_' + AmlCaViewModel.ControlResponselvlList()[i].Response().replace(/\s+/g, '') + '" class="form-control"  style="height:9em !important" placeholder="' + AmlCaViewModel.ControlResponselvlList()[i].Response() + ' Question" data-bind="value:ControlQuestionList().Question" type="text" ></textarea>' +
                                    '</div>' +
                                    '</div>';
                            }
                        }
                    }
                    if (!AmlCaViewModel.isGlobalFlag()) {
                        questionHTMl += '<div class="form-group">' +
                            '<label class="col-xs-1 col-sm-1 col-md-1 col-lg-1 control-label"></label>' +
                            '<input class="col-xs-2 col-sm-2 col-md-2 col-lg-2 control-label" type= "checkbox" style="height:20px; width:20px" id= "GlobalResponsesCheck" placeholder= "Global Responses" data-bind="checked: GlobalResponses" >' +
                            '<label class="col-xs-8 col-sm-8 col-md-8 col-lg-8 control-label" style="padding-top:1px">Copy Globally Configured Responses for this Question</label>' +
                            '</div >';
                    }


                    document.getElementById('Dynamicquestion').innerHTML = questionHTMl;
                    ko.cleanNode(document.getElementById('Dynamicquestion'));
                    ko.applyBindings(AmlCaViewModel, document.getElementById("Dynamicquestion"));
                    $("#ControlQuestionScroll").css({ "height": "auto", "max-height": "auto", "overflow-y": "auto", "overflow-x": "hidden" });
                    $("modalContent").css({ "height": "auto", "max-height": "auto" });
                    //Add language text areas
                    CntrlFactorLanguageAdded();
                }
                else {
                    AmlCaViewModel.LanguageCntrlFactorDdVisible(false);
                    $('#Dynamicquestion').empty();
                    $('#DynamicquestionLang').empty();
                    AmlCaViewModel.ControlSaveDisabled(true);
                    $('#ControlQuestionScroll').removeAttr("style");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CntrlFactorResponseSelected() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        //working here also

        function AddHeaderTypeQuestion() {
            try {
                AmlCaViewModel.SelectedResponseOptionType([]);
                AmlCaViewModel.SelectedLanguageCntrlFactorType([]);
                AmlCaViewModel.controlResponseTypesAdd(false);
                AmlCaViewModel.ResponseOptionddFlag(false);
                $('#ControlResponseTypes').multiselect('refresh');
                $('#RAControlFactorLanguage').multiselect('refresh');
                $('#controlResponseTypesAdd').hide();

                if (document.getElementById('DynamicquestionLang') != null) {
                    document.getElementById('DynamicquestionLang').innerHTML = "";
                    ko.cleanNode(document.getElementById('DynamicquestionLang'));
                    ko.applyBindings(AmlCaViewModel, document.getElementById("DynamicquestionLang"));
                }

                AmlCaViewModel.LanguageCntrlFactorDdVisible(true);
                AmlCaViewModel.ControlQuestionType(true);
                $('#RAControlFactorLanguage').multiselect();
                AmlCaViewModel.ControlSaveDisabled(true);
                $('#Dynamicquestion').empty();
                var questionHTMl = '<div id="HeaderTypeQuestion" class="form-group">' +
                    '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label"> Header Question</label>' +
                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                    '<textarea id="question_HeaderType" class="form-control"  style="height:9em !important" placeholder="Header Question" data-bind="value:ControlQuestionList().Question" type="text" ></textarea>' +
                    '</div>' +
                    '</div>';

                document.getElementById('Dynamicquestion').innerHTML = questionHTMl;
                ko.cleanNode(document.getElementById('Dynamicquestion'));
                ko.applyBindings(AmlCaViewModel, document.getElementById("Dynamicquestion"));

                $("#ControlQuestionScroll").css({ "height": "37rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                //Add language text areas
                CntrlFactorLanguageAdded();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AddHeaderTypeQuestion() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function RemoveHeaderTypeQuestion() {
            try {
                $('#controlResponseTypesAdd').show();
                if (document.getElementById('HeaderTypeQuestion') != null) {
                    AmlCaViewModel.LanguageCntrlFactorDdVisible(false);
                    document.getElementById('HeaderTypeQuestion').innerHTML = "";
                    ko.cleanNode(document.getElementById('HeaderTypeQuestion'));
                    ko.applyBindings(AmlCaViewModel, document.getElementById("HeaderTypeQuestion"));
                    $("#ControlQuestionScroll").removeAttr("Style");
                }

                if (document.getElementById('DynamicquestionLangHeaderQuestion') != null) {
                    document.getElementById('DynamicquestionLangHeaderQuestion').innerHTML = "";
                    ko.cleanNode(document.getElementById('DynamicquestionLangHeaderQuestion'));
                    ko.applyBindings(AmlCaViewModel, document.getElementById("DynamicquestionLangHeaderQuestion"));
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RemoveHeaderTypeQuestion() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }


        function LanguageFactorModel(item, languageId) {
            try {
                var self = this;
                if (AmlCaViewModel.FactorHeaderType() == true) {
                    self.Question = $('#Header' + languageId).val();
                    self.QuestionLevel = item;
                }
                else {
                    self.Question = $('#question_' + item.replace("&amp;", "&").replace(/\s+/g, '') + languageId).val();
                    self.QuestionLevel = item;
                }
                self.LanguageType = languageId;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LanguageFactorAdded() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        };

        function CntrlFactorLanguageAdded() {
            try {
                if (document.getElementById('HeaderTypeQuestion') != null) {
                    var selectedLanguage = AmlCaViewModel.SelectedLanguageCntrlFactorType();
                    $('#DynamicquestionLangHeaderQuestion').empty();
                    var langQuestionHTMl = "";

                    for (var k = 0; k < AmlCaViewModel.SelectedLanguageCntrlFactorType().length; k++) {
                        for (var p = 0; p < AmlCaViewModel.ObjGeneralSettings.LanguageList().length; p++) {
                            if (parseInt(AmlCaViewModel.SelectedLanguageCntrlFactorType()[k]) == AmlCaViewModel.ObjGeneralSettings.LanguageList()[p].LANGUAGE_ID()) {

                                langQuestionHTMl += '<div class="form-group">' +
                                    '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Header Question' + ' (' + AmlCaViewModel.ObjGeneralSettings.LanguageList()[p].LANGUAGENAME() + ')' + '</label>' +
                                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                    '<textarea id="Header' + AmlCaViewModel.SelectedLanguageCntrlFactorType()[k] + '" class="form-control"  style="height:9em !important" placeholder="Header Question in ' + AmlCaViewModel.ObjGeneralSettings.LanguageList()[p].LANGUAGENAME() + '" data-bind="value:ControlLanguageFactorList().Question" type="text" ></textarea>' +
                                    '</div>' +
                                    '</div>';

                            }
                        }
                    }
                    document.getElementById('DynamicquestionLangHeaderQuestion').innerHTML = langQuestionHTMl;
                    ko.cleanNode(document.getElementById('DynamicquestionLangHeaderQuestion'));
                }
                else {
                    var selectedLanguage = AmlCaViewModel.SelectedLanguageCntrlFactorType();
                    $('#DynamicquestionLang').empty();
                    var langQuestionHTMl = "";
                    for (var k = 0; k < AmlCaViewModel.SelectedLanguageCntrlFactorType().length; k++) {
                        for (var p = 0; p < AmlCaViewModel.ObjGeneralSettings.LanguageList().length; p++) {
                            if (parseInt(AmlCaViewModel.SelectedLanguageCntrlFactorType()[k]) == AmlCaViewModel.ObjGeneralSettings.LanguageList()[p].LANGUAGE_ID()) {

                                for (var j = 0; j < AmlCaViewModel.SelectedResponseOptionType().length; j++) {
                                    for (var i = 0; i < AmlCaViewModel.ControlResponselvlList().length; i++) {
                                        if (parseInt(AmlCaViewModel.SelectedResponseOptionType()[j]) == AmlCaViewModel.ControlResponselvlList()[i].Response_Ref_Id()) {

                                            langQuestionHTMl += '<div class="form-group">' +
                                                '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">' + AmlCaViewModel.ControlResponselvlList()[i].Response() + ' Question' + ' (' + AmlCaViewModel.ObjGeneralSettings.LanguageList()[p].LANGUAGENAME() + ')' + '</label>' +
                                                '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                                                '<textarea id="question_' + AmlCaViewModel.ControlResponselvlList()[i].Response().replace(/\s+/g, '') + AmlCaViewModel.SelectedLanguageCntrlFactorType()[k] + '" class="form-control"  style="height:9em !important" placeholder="' + AmlCaViewModel.ControlResponselvlList()[i].Response() + ' Question in ' + AmlCaViewModel.ObjGeneralSettings.LanguageList()[p].LANGUAGENAME() + '" data-bind="value:ControlLanguageFactorList().Question" type="text" ></textarea>' +
                                                '</div>' +
                                                '</div>';
                                        }
                                    }
                                }

                            }
                        }
                    }
                    document.getElementById('DynamicquestionLang').innerHTML = langQuestionHTMl;
                    ko.cleanNode(document.getElementById('DynamicquestionLang'));
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CntrlFactorLanguageAdded() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function EditControlQuestionPopUp(data, event) {
            try {
                var ControlAreaId = AmlCaViewModel.SelectedRiskAreaId();
                AmlCaViewModel.ResponseUneditableText(data.ResponseQuestionName().replace("|", ", "));
                $.ajax({
                    url: "/api/ControlArea/GetAllControlQuestionDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { ControlAreaId: ControlAreaId, ControlQuestionId: data.ControlQuestionId(), ZAT_UID: AmlCaViewModel.ClickedAssessmentTypeId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in EditControlQuestionPopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, error) {
                var MappedControlQuestion = $.map(jsonResult.ControlQuestionSubList, function (result) {
                    return new ControlQuestionModel(result);
                });
                AmlCaViewModel.ControlQUestionSubList(MappedControlQuestion);
                EditControlQuestionPopUp2(data, jsonResult);
            }
            function ajaxFail(error, status) {
                if (error.status == 401) {
                    app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in EditControlQuestionPopUp() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };

        }
        function changedResponseType() {
            try {
                AmlCaViewModel.ResponseOptionList([]);
                for (var i = 0; i < AmlCaViewModel.ControlQuestionPop().selectedResponseOptionType().length; i++) {
                    for (var j = 0; j < AmlCaViewModel.ControlResponselvlList().length; j++) {
                        if (AmlCaViewModel.ControlQuestionPop().selectedResponseOptionType()[i] == AmlCaViewModel.ControlResponselvlList()[j].Response_Ref_Id()) {
                            AmlCaViewModel.ResponseOptionList.push(new ResponseOptionModel({ "ResponseTypeId": AmlCaViewModel.ControlResponselvlList()[j].Id(), "ResponseTypeName": AmlCaViewModel.ControlResponselvlList()[j].Response(), "OptionTypeShortName": "" }));
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in changedResponseType() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function EditControlQuestionPopUp2(data, result) {
            try {
                AmlCaViewModel.QuestionGuideline(result.QuestionGuideline);
                // AmlCaViewModel.selectedOptionType(result.OptionTypeShortName);
                AmlCaViewModel.FactorConditionalType(false);
                AmlCaViewModel.ControlSaveDisabled(true);
                AmlCaViewModel.LanguageCntrlFactorDdVisible(false);
                AmlCaViewModel.ResponseOptionList(result.ResponseOptionTypeModelObject);
                AmlCaViewModel.ResponseOptionddFlag(false);
                AmlCaViewModel.AddConditionalQuestionType(false);
                for (var i = 0; i < AmlCaViewModel.ControlQUestionSubList().length; i++) {
                    if (AmlCaViewModel.ControlQUestionSubList()[i].NotApplicable() == 0) {
                        AmlCaViewModel.NAChecked(false);
                        var x = AmlCaViewModel.ControlQUestionSubList()[i].ControlQuestionName().split('}')
                        if (x.length == 1) {
                            AmlCaViewModel.ControlQUestionSubList()[i].OEQuestiondata(x[0].substring(x[0].indexOf(":") + 1, x[0].length));
                        } else {
                            AmlCaViewModel.ControlQUestionSubList()[i].CDQuestiondata(x[0].substring(x[0].indexOf(":") + 1, x[0].length));
                            AmlCaViewModel.ControlQUestionSubList()[i].OEQuestiondata(x[1].substring(x[1].indexOf(":") + 1, x[1].length));
                        }
                    }
                    else {

                        AmlCaViewModel.ControlQUestionSubList()[i].NAQuestionData(((data.ControlQuestionName())).replace(/}/g, ''));
                        AmlCaViewModel.NAChecked(true);

                    }
                }

                var NewData = new ControlQuestionModel({
                    ControlQuestionId: data.ControlQuestionId(),
                    ControlQuestionNameNconcat: data.ControlQuestionNamen()
                });

                AmlCaViewModel.SelectedResponseApplicabilityType([]);
                if (AmlCaViewModel.ControlQUestionSubList()[0].HeaderTypeControl() == true) {
                    AmlCaViewModel.ControlQuestionPopUpData(NewData);
                    if (result)
                        AmlCaViewModel.ControlQuestionPopUpAreasApplicable(result.ControlAreaName);
                    AmlCaViewModel.ControlQuestionPopUpTitle("Edit Control Question");
                    AmlCaViewModel.ControlQuestionPopUpType("Edit");
                    $('#frmControlQuestionEdit').modal('show');
                    //CKEDITOR.replace('QuestionGuidelineEdit',
                    //{
                    //    //allowedContent: true,
                    //    //extraAllowedContent: '*(GuidelineCKEEditor)'
                    //    extraAllowedContent : '*(*);*{*}'
                    //});

                    $('#QuestionResponseTypes').removeClass('d-flex').hide();
                }
                else {
                    var mappedResponses = [];
                    for (var m = 0; m < AmlCaViewModel.ControlQUestionSubList().length; m++) {
                        for (var n = 0; n < AmlCaViewModel.ControlResponselvlList().length; n++) {
                            //if ((AmlCaViewModel.ControlQUestionSubList()[m].ControlResponseId() == AmlCaViewModel.ControlResponselvlList()[n].Id()) || (AmlCaViewModel.ControlQUestionSubList()[m].ControlResponseId() == -99)) {
                            if ((AmlCaViewModel.ControlQUestionSubList()[m].ControlResponseId() == AmlCaViewModel.ControlResponselvlList()[n].Id())) {
                                mappedResponses.push(AmlCaViewModel.ControlResponselvlList()[n]);
                                if (AmlCaViewModel.ControlQUestionSubList()[m].ResponseApplicableFlag() == 'A') {
                                    AmlCaViewModel.SelectedResponseApplicabilityType.push(AmlCaViewModel.ControlResponselvlList()[n].Id());
                                }
                            }
                        }
                    }

                    AmlCaViewModel.ControlResponseApplicabilityList(mappedResponses);

                    AmlCaViewModel.ControlQuestionPopUpData(NewData);
                    AmlCaViewModel.ControlQuestionPopUpTitle("Edit Control Question");
                    AmlCaViewModel.ControlQuestionPopUpType("Edit");
                    $('#frmControlQuestionEdit').modal('show');
                    //CKEDITOR.replace('QuestionGuidelineEdit',
                    //    {

                    //        removeButtons: 'Copy,Cut,Paste,Undo,Redo,Print,Form,TextField,Textarea,Button,SelectAll,NumberedList,BulletedList,CreateDiv,Table,PasteText,PasteFromWord,Select,HiddenField,Anchor'
                    //    });
                    $('#QuestionResponseTypes').show();
                    $('#EditQuestionResp').multiselect();
                    $('#EditQuestionResp').multiselect('refresh');
                }


                document.getElementById('EditQuestionAppli').innerHTML = data.AssessmentType();
                $('#EditQuestionapp').css({
                    'margin-top': '1rem'
                });
                CntrlChangeInResponseApplicability();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditControlQuestionPopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function CntrlChangeInResponseApplicability() {
            try {
                if (AmlCaViewModel.ControlQUestionSubList()[0].HeaderTypeControl() == false) {
                    for (var i = 0; i < AmlCaViewModel.ControlQUestionSubList().length; i++) {
                        AmlCaViewModel.ControlQUestionSubList()[i].ResponseApplicableFlag('NA');
                        for (var j = 0; j < AmlCaViewModel.SelectedResponseApplicabilityType().length; j++) {
                            if (AmlCaViewModel.ControlQUestionSubList()[i].ControlResponseId() == AmlCaViewModel.SelectedResponseApplicabilityType()[j] || AmlCaViewModel.ControlQUestionSubList()[i].ControlResponseId() == -99) {
                                AmlCaViewModel.ControlQUestionSubList()[i].ResponseApplicableFlag('A');
                            }

                        }
                    }
                }

                AddDynamicControlFactorElementsForEdit();
                for (var i = 0; i < AmlCaViewModel.ControlQUestionSubList().length; i++) {
                    if (AmlCaViewModel.ControlQUestionSubList()[i].ResponseApplicableFlag() == 'A') {
                        if (AmlCaViewModel.ControlQUestionSubList()[i].ControlQuestionName() != null && AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName() != null) {

                            document.getElementById('question_' + AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName().replace(/\s+/g, '')).innerHTML = AmlCaViewModel.ControlQUestionSubList()[i].ControlQuestionName();
                        }
                    }

                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CntrlChangeInResponseApplicability() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function AddDynamicControlFactorElementsForEdit() {
            try {
                $('#DynamicquestionEditLang').empty();
                var questionHTMl = "";
                for (var i = 0; i < AmlCaViewModel.ControlQUestionSubList().length; i++) {
                    if (AmlCaViewModel.ControlQUestionSubList()[i].ResponseApplicableFlag() == 'A') {
                        $.each(AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList(), function (key, value) {

                            if (value.Question != '' && value.Question != 'undefined') { //QuestionLevel
                                questionHTMl += '<div class="form-group d-flex nd-flex">' +
                                    '<label class="col-lg-2 control-label d-flex">' + value.QuestionLevel + ' Question' + ' (' + value.LanguageName + ')' + '</label>' +
                                    '<div class="col-lg-10">' +
                                    '<textarea id="question_' + value.QuestionLevel.replace(/\s+/g, '') + value.LanguageType + '" class="form-control"  style="height:9em !important"  type="text" >' + value.Question + '</textarea>' +
                                    '</div>' +
                                    '</div>';
                            }
                        });
                    }

                }


                if (questionHTMl != '' && questionHTMl != 'undefined') {
                    ko.cleanNode(document.getElementById('DynamicquestionEditLang'));
                    document.getElementById('DynamicquestionEditLang').innerHTML = questionHTMl;
                    ko.applyBindings(AmlCaViewModel, document.getElementById("DynamicquestionEditLang"));
                    $("#ControlQuestionEditScroll").css({ "height": "37rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                } else {
                    $("#ControlQuestionEditScroll").removeAttr("Style");
                }

                $('#DynamicquestionEdit').empty();
                questionHTMl = '';
                for (var i = 0; i < AmlCaViewModel.ControlQUestionSubList().length; i++) {
                    if (AmlCaViewModel.ControlQUestionSubList()[i].ResponseApplicableFlag() == 'A') {
                        responseName = AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName();
                        questionHTMl += '<div class="form-group d-flex nd-flex">' +
                            '<label class="col-lg-2 control-label">' + responseName + ' Question</label>' +
                            '<div class="col-lg-10">' +
                            '<textarea id="question_' + responseName.replace(/\s+/g, '') + '" class="form-control"  style="height:9em !important" type="text" ></textarea>' +
                            '</div>' +
                            '</div>';
                    }

                }



                document.getElementById('DynamicquestionEdit').innerHTML = questionHTMl;
                ko.cleanNode(document.getElementById('DynamicquestionEdit'));

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AddDynamicControlFactorElementsForEdit() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function AddDynamicControlQuestion(responseName, responseData) {
            try {
                $('#Dynamicquestion').empty();
                var questionHTMl = '<div class="form-group d-flex nd-flex">' +
                    '<label class="col-lg-2 control-label">' + responseName + ' Question</label>' +
                    '<div class="col-lg-10">' +
                    '<textarea id="question_' + responseName.replace(/\s+/g, '') + '" class="form-control"  style="height:9em !important" data-bind="value:ControlQuestionList().Question" type="text" ></textarea>' +
                    '</div>' +
                    '</div>';

                document.getElementById('Dynamicquestion').innerHTML = questionHTMl;
                ko.cleanNode(document.getElementById('Dynamicquestion'));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AddDynamicControlFactorElements() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function UpdateControlQuestion(data) {
            try {
                var controlAreaId = AmlCaViewModel.SelectedRiskAreaId();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/ControlArea/UpdateControlAreaQuestion",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({
                        ControlAreaId: controlAreaId,
                        ControlQuestionId: data.ControlQuestionId(),
                        ControlFactorLanguageList: AmlCaViewModel.ControlQuestionLanguageSuList(),
                        ControlQuestionList: AmlCaViewModel.EditControlQuestionList(),
                        QuestionGuideline: AmlCaViewModel.QuestionGuideline()
                        //OptionTypeShortName: AmlCaViewModel.selectedOptionType()
                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateControlQuestion() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#frmControlQuestionEdit').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (parseInt(jsonResult) == 1) {
                        GetControlQuestionsNLevel(AmlCaViewModel.SelectedRiskAreaId());

                        logger.logSuccess('Control Question details updated successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                    }
                    else if (parseInt(jsonResult) == 2) {
                        logger.logError('Control Question already exists.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else if (parseInt(jsonResult) == 3) {
                        logger.logError('Control Question cannot be edited as it is already used in the application.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while updating Control Question details.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateControlQuestion() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateControlQuestion() method in AMLControlAreaSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateControlQuestion() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            };
        }

        function SaveEditControlQuestionPopUp(data, event) {
            try {
                AmlCaViewModel.EditControlQuestionList([]);
                AmlCaViewModel.ControlQuestionLanguageSuList([]);
                //AmlCaViewModel.QuestionGuideline(CKEDITOR.instances["QuestionGuidelineEdit"].getData());
                $('#valErrorECQ').hide();
                for (var i = 0; i < AmlCaViewModel.ControlQUestionSubList().length; i++) {
                    if (AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList() != null && AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList().length > 0) {
                        for (var j = 0; j < AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList().length; j++) {
                            if ($('#question_' + AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName().replace(/\s+/g, '') + AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].LanguageType.toString()).val() != undefined)
                                AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].Question = $('#question_' + AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName().replace(/\s+/g, '') + AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].LanguageType.toString()).val();
                            AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].QuestionLevel = AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName();
                            AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].LanguageType = AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].LanguageType.toString();
                            //data.ControlFactorLanguageList()[i].NotApplicableQuestion = $('#NAquestion' + data.ControlFactorLanguageList()[i].LanguageType.toString()).val();

                            if (AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j].Question == "") {
                                $('#valErrorECQ').show();
                                $('#valErrorECQ').text('Response Types in ' + GetLanguageName(data.ControlFactorLanguageList()[i].LanguageType) + ' are required.');
                                return;
                            } else {
                                $('#valErrorECQ').text('');
                            }
                            AmlCaViewModel.ControlQuestionLanguageSuList.push(AmlCaViewModel.ControlQUestionSubList()[i].ControlFactorLanguageList()[j]);
                        }

                    }
                    if ($('#question_' + AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName().replace(/\s+/g, '')).val() != undefined)
                        AmlCaViewModel.ControlQUestionSubList()[i].ControlQuestionName($('#question_' + AmlCaViewModel.ControlQUestionSubList()[i].ResponseQuestionName().replace(/\s+/g, '')).val());
                    AmlCaViewModel.EditControlQuestionList.push(new ControlEditQuestion(AmlCaViewModel.ControlQUestionSubList()[i]));
                    // AmlCaViewModel.EditControlQuestionList.push()
                }
                var CompleteQuestion = '';

                if (ValidateControlQuestionEdit(AmlCaViewModel.EditControlQuestionList(), data.ControlQuestionId()) && $('#valErrorECQ').text() == "") {
                    UpdateControlQuestion(data);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveEditControlQuestionPopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ControlEditQuestion(item) {
            var self = this;
            self.ReferenceId = ko.observable(item.ControlReferenceId());
            self.QuestionLevel = ko.observable(item.ResponseQuestionName());
            self.Question = ko.observable($('<div/>').html(item.ControlQuestionName()).text());
            self.QuestionLevelId = ko.observable(item.ControlResponseId());
            self.ResponseApplicableFlag = ko.observable(item.ResponseApplicableFlag());

        }
        function UpFunctionalityRiskAreaQuestion(data, event) {
            try {
                $('#valErrorControlQuestion').hide();
                for (var i = 0; i < AmlCaViewModel.RiskQuestionReorderList().length; i++) {

                    if (data.ControlQuestionId() == AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionId()) {
                        if (i == 0) {
                            $('#valErrorControlQuestion').show();
                            document.getElementById('valErrorControlQuestion').innerHTML = "This cannot go further up.";
                        }
                        else {
                            var x = AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionId();
                            var y = AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionName();

                            AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionId(AmlCaViewModel.RiskQuestionReorderList()[i - 1].ControlQuestionId());
                            AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionName(AmlCaViewModel.RiskQuestionReorderList()[i - 1].ControlQuestionName());

                            AmlCaViewModel.RiskQuestionReorderList()[i - 1].ControlQuestionId(x);
                            AmlCaViewModel.RiskQuestionReorderList()[i - 1].ControlQuestionName(y);
                            break;
                        }
                    }
                }
                for (var i = 0; i < $($('#questionsortorder').find('tr')).length - 1; i++) {
                    var unprocessedtext = $($($($('#questionsortorder').find('tr')).get(i + 1)).find('td')).get(1).innerHTML;
                    var processedtext = unprocessedtext.replace(/{/g, '<br/>');
                    processedtext = processedtext.replace(new RegExp('&lt;b&gt;', 'g'), '<b>');
                    processedtext = processedtext.replace(new RegExp('&lt;/b&gt;', 'g'), '</b>');
                    $($($($('#questionsortorder').find('tr')).get(i + 1)).find('td')).get(1).innerHTML = processedtext;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UpFunctionalityRiskAreaQuestion() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function DownFunctionalityRiskAreaQuestion(data, event) {
            try {

                $('#valErrorControlQuestion').hide();
                for (var i = 0; i < AmlCaViewModel.RiskQuestionReorderList().length; i++) {

                    if (data.ControlQuestionId() == AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionId()) {
                        if (i == AmlCaViewModel.RiskQuestionReorderList().length - 1) {
                            $('#valErrorControlQuestion').show();
                            document.getElementById('valErrorControlQuestion').innerHTML = "This cannot go further down.";
                        }
                        else {
                            var x = AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionId();
                            var y = AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionName();

                            AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionId(AmlCaViewModel.RiskQuestionReorderList()[i + 1].ControlQuestionId());
                            AmlCaViewModel.RiskQuestionReorderList()[i].ControlQuestionName(AmlCaViewModel.RiskQuestionReorderList()[i + 1].ControlQuestionName());

                            AmlCaViewModel.RiskQuestionReorderList()[i + 1].ControlQuestionId(x);
                            AmlCaViewModel.RiskQuestionReorderList()[i + 1].ControlQuestionName(y);
                            break;
                        }
                    }
                }
                for (var i = 0; i < $($('#questionsortorder').find('tr')).length - 1; i++) {
                    var unprocessedtext = $($($($('#questionsortorder').find('tr')).get(i + 1)).find('td')).get(1).innerHTML;
                    var processedtext = unprocessedtext.replace(/{/g, '<br/>');
                    processedtext = processedtext.replace(new RegExp('&lt;b&gt;', 'g'), '<b>');
                    processedtext = processedtext.replace(new RegExp('&lt;/b&gt;', 'g'), '</b>');
                    $($($($('#questionsortorder').find('tr')).get(i + 1)).find('td')).get(1).innerHTML = processedtext;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UpFunctionalityRiskAreaQuestion() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }


        function CancelRiskQuestionSortOrder(data, event) {
            try {
                AmlCaViewModel.RiskQuestionReorderList([])
                var NewMappedObj = $.map(AmlCaViewModel.RiskQuestionReorderListDup(), function (item) {
                    return new ControlQuestionSortOrderDupModel(item)
                })
                AmlCaViewModel.RiskQuestionReorderList(NewMappedObj);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CancelRiskQuestionSortOrder() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ValidateControlQuestionEdit(data, RowIndex) {
            try {
                var Result = false;

                var DuplicateCount = 0;
                var concatStr = "";
                if (AmlCaViewModel.ControlQuestionList() != undefined) {
                    for (var j = 0; j < data.length; j++) {
                        concatStr += data[j].QuestionLevel() + ":" + data[j].Question();
                        if (j != data.length - 1) {
                            concatStr += "{ "
                        }
                    }
                    //here
                    var ParentQtnName;
                    for (var i = 0; i < AmlCaViewModel.ControlQuestionList().length; i++) {
                        ParentQtnName = AmlCaViewModel.ControlQuestionList()[i].ControlQuestionName();
                        ParentQtnName = ParentQtnName.replace(new RegExp('<b>', 'g'), '');
                        ParentQtnName = ParentQtnName.replace(new RegExp('</b>', 'g'), '');
                        if ((ParentQtnName.toUpperCase().trim() == concatStr.toUpperCase().trim()) && AmlCaViewModel.ControlQuestionList()[i].ControlQuestionId() != RowIndex) {
                            DuplicateCount++;
                            break;
                        }
                    }
                }

                for (var j = 0; j < data.length; j++) {
                    if (data[j].Question() == "") {
                        $('#valErrorECQ').text("Control Question cannot be left blank.");
                        $('#valErrorECQ').show();
                    }
                    else if (data[j].Question().length > 2000) {
                        $('#valErrorECQ').text("Control Question cannot be of more than 2000 characters.");
                        $('#valErrorECQ').show();
                    }
                    else if (DuplicateCount > 0) {
                        $('#valErrorECQ').text("The Control Question Name already exists.");
                        $('#valErrorECQ').show();
                    }
                    else if (AmlCaViewModel.QuestionGuideline().length > 4000) {
                        $('#valErrorECQ').show();
                        $('#valErrorECQ').text('Control Question Guideline cannot exceed 4000 characters. Please enter a valid Guideline.');
                    }
                    else {
                        $('#valErrorECQ').text("");
                        $('#valErrorECQ').hide();
                        Result = true;
                    }
                }
                return Result;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateControlQuestionEdit() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function OpenSortOrderQuestionPopUp() {
            try {
                //here
                for (var i = 0; i < $($('#questionsortorder').find('tr')).length - 1; i++) {
                    var unprocessedtext = $($($($('#questionsortorder').find('tr')).get(i + 1)).find('td')).get(1).innerHTML;
                    var processedtext = unprocessedtext.replace(/{/g, '<br/>');
                    processedtext = processedtext.replace(new RegExp('&lt;b&gt;', 'g'), '<b>');
                    processedtext = processedtext.replace(new RegExp('&lt;/b&gt;', 'g'), '</b>');
                    $($($($('#questionsortorder').find('tr')).get(i + 1)).find('td')).get(1).innerHTML = processedtext;
                }
                AmlCaViewModel.popUpTitle("Re-Order");
                AmlCaViewModel.addPopUpCss(true);
                $('#frmRiskQuestionReordermodel').modal('show');
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in OpenSortOrderQuestionPopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }



        function SaveRiskQuestionSortOrder() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/ControlRiskQuestionSortOrder?AssessmentType=" + AmlCaViewModel.AssessmentType(),
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(AmlCaViewModel.RiskQuestionReorderList(), function (item) {
                        return { ControlQuestionId: item.ControlQuestionId(), SortOrder: item.SortOrder };
                    }))
                })
                    .success(ajaxSuccessOverall)
                    .fail(ajaxFailOverall);

                function ajaxSuccessOverall(jsonResult, status) {
                    try {
                        if (jsonResult != null) {
                            if (parseInt(jsonResult) != 1) {
                                $('#frmRiskQuestionReordermodel').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                GetControlQuestionsNLevel(AmlCaViewModel.SelectedRiskAreaId());
                                logger.logSuccess('Sort Order saved successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                            }
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                        logger.logMessage(msg);
                    }
                }
                function ajaxFailOverall(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
        function OpenConfigureResponseLevelsPopup() {
            $('#rsplvlError1').text('');
            AmlCaViewModel.ControlAreaPopUpTitle("Configure Response Levels");//change name
            AmlCaViewModel.addPopUpCss(true);
            $('#frmConfigrsplvl').modal('show');//change popup name
            GetResponseLevels();
        }
        function DeletelvlResponses(data) {
            app.showMessage('Are you sure you want to Delete this Response Level?' + "<br/><br/><b>", 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteResponseItem(data);
                    }
                });
        }
        function deleteResponseItem(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                deleteControlResponseType = {
                    url: "/api/Configuration/deleteControlResponseItem",
                    type: "POST",
                    data: { RESPONSE_ID: data.Id(), RESPONSE_DESCRIPTION: data.Response() },
                    headers: headers,
                    async: false
                };
                $.ajax(deleteControlResponseType)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteResponseItem() method in RiskArea&Factor.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (parseInt(jsonResult) == 2) {
                    logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                else if (jsonResult != null) {
                    GetResponseLevels();
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
            };
            function ajaxFail(error, status) {
                if (error.status == 401) {
                    app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteResponseItem() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function deleteSubResponseItem(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                deleteControlSubResponseType = {
                    url: "/api/Configuration/deleteControlSubResponseItem",
                    type: "POST",
                    data: { RESPONSE_ID: data.Id(), RESPONSE_DESCRIPTION: data.Response() },
                    headers: headers,
                    async: false
                };
                $.ajax(deleteControlSubResponseType)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in deleteSubResponseItem() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (parseInt(jsonResult) == 2) {
                    logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(AmlCaViewModel), true);
                }
                else if (jsonResult != null) {
                    AmlCaViewModel.ResposneSublevelList.remove(data);
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
            };
            function ajaxFail(error, status) {
                if (error.status == 401) {
                    app.showMessage((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "", [((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name)], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == ((!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteSubResponseItem() method in AMLControlAreaSetup.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ResponselvlAddButton() {
            var NewRsplvlObject = new ResponselevelModel({ Id: '999', Response: "", Description: "", Response_Ref_Id: "" })
            AmlCaViewModel.ControlResponselvlList.push(NewRsplvlObject);
        }
        function ResponseSublvlAddButton() {
            var NewRsplvlObject = new ResponseDataModel({ Id: '999', Response: "", Score: "" })
            AmlCaViewModel.ResposneSublevelList.push(NewRsplvlObject);
        }
        function SavelvlResponses(data, event) {
            try {
                $('#rsplvlError1').text('');
                closeAllExpandedRows();
                $.map(AmlCaViewModel.ControlResponselvlList(), function (item) {
                    if ($('#rsplvlError1').text() == "") {
                        if (!AmlCaViewModel.AlphaNumbers().test(item.Response().replace(/\s+/g, ''))) {
                            $('#rsplvlError1').show();
                            $('#rsplvlError1').text('Response Value can have only alphabets and numbers.');
                            return false;
                        } else {
                            $('#rsplvlError1').text('');
                        }
                    } else
                        return;
                })
                var total = 0;
                if (AmlCaViewModel.ResponseWithWeights()) {//If we have weights in responses
                    for (i = 0; i < AmlCaViewModel.ControlResponselvlList().length; i++) {
                        total += parseFloat(AmlCaViewModel.ControlResponselvlList()[i].Response_weightage());
                    }
                    if (total != 100.00) {
                        $('#rsplvlError1').show();
                        $('#rsplvlError1').text('Response Weightage must sum upto complete 100%');
                        return false;
                    }
                }
                else {//If we do not have weights in responses
                    for (i = 0; i < AmlCaViewModel.ControlResponselvlList().length; i++) {
                        AmlCaViewModel.ControlResponselvlList()[i].Response_weightage(0);
                    }
                }

                if ($('#rsplvlError1').text() == "") {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/ControlArea/SaveControlResponseLevel",
                        type: "POST",
                        headers: headers,
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(AmlCaViewModel.ControlResponselvlList(), function (item) {
                            return { Id: item.Id(), Response: item.Response(), Description: item.Description(), Response_weightage: item.Response_weightage(), GlobalFlag: AmlCaViewModel.isGlobalFlag() };
                        }))
                    })
                        .success(function (jsonResult, error) {
                            $('#rsplvlError1').text('');
                            if (parseInt(jsonResult) > 0) {
                                GetResponseLevels();
                                logger.logSuccess('Control Response details added  successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                                $('#frmConfigrsplvl').modal('hide');
                            }
                            else if (parseInt(jsonResult) == 0) {
                                logger.logError('An error has occurred while adding the Control Response Level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                            }
                        })
                        .fail(function (jsonResult, error) {
                            $('#rsplvlError1').text('');
                            logger.logError('An error has occurred while adding the Control Response Level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                        });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SavelvlResponses() method in AMLControlAreaSetup.js';
                logger.logMessage(msg); OpenConfigureResponseLevelsPopup
            }
        }
        function GetAllOptionsType() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetAllOptionsType",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        AmlCaViewModel.OptionsTypeList([]);
                        if (jsonResult != null) {
                            AmlCaViewModel.OptionsTypeList(jsonResult);
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllOptionsType() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetResponseLevels() {
            try {
                return $.ajax({
                    url: "/api/ControlArea/GetControlResponseLevel",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        AmlCaViewModel.ControlResponselvlList([]);

                        if (jsonResult != null && jsonResult.length != 0) {
                            if ($.fn.DataTable.isDataTable('#ControllevelResponseTable')) {
                                tableObj = $('#ControllevelResponseTable').DataTable();
                                tableObj.destroy();
                                $("#ControllevelResponseTable tbody tr").remove();
                            }
                            var MappedResponseLevels = $.map(jsonResult, function (result) {
                                return new ResponselevelModel(result);
                            });
                            responseLevel = jsonResult;
                            AmlCaViewModel.ControlResponselvlList(MappedResponseLevels);
                            AmlCaViewModel.isGlobalFlag(AmlCaViewModel.ControlResponselvlList()[0].GlobalFlag());
                            AmlCaViewModel.isGlobalFlagCopy(AmlCaViewModel.ControlResponselvlList()[0].GlobalFlag());
                            AmlCaViewModel.ResponseWithWeights(AmlCaViewModel.ControlResponselvlList()[0].WeightedAverage())

                            $('#ControllevelResponseTable').DataTable({ bFilter: false, aaSorting: false });
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while fetching the Response level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetResponseLevels() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function trclick(data, event) {
            try {
                RfTableObj = $('#ControllevelResponseTable').DataTable();
                var tr = $(event.currentTarget).closest('tr');
                var row = RfTableObj.row(tr);
                checkExpandedRow(row, false);
                if (row.child.isShown()) {
                    //close the open row
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    GetallSubResponses(row.data()[0]).then(function () {
                        AmlCaViewModel.SelectedResponseId(row.data()[0]);
                        row.child(format(row.data())).show();
                        tr.addClass('shown');
                        ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: AmlCaViewModel.ResposneSublevelList }, AmlCaViewModel);
                        if (AmlCaViewModel.ControlsAccess())
                            ko.applyBindingsToNode($('#btnsfReorder'), { disabled: true, click: AmlCaViewModel.OpenRiskSubFactorOrderPopup }, AmlCaViewModel);
                        ko.applyBindingsToNode($('#addSubFactorBtn'), { click: AmlCaViewModel.addSubResponseFunctionality }, AmlCaViewModel);
                        ko.applyBindingsToNode($('#SaveResponseRangebtn'), { click: AmlCaViewModel.SaveSubResponseFunctionality }, AmlCaViewModel);
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: trclick() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function format(data) {
            try {


                var SfHtml = '<div class="child-active" style="margin-left:3em;">' +
                    '<div class="panel panel-success panel-margin">' +
                    '<div class="panel-heading">' +
                    '<h5 class="panel-title riskFactorCellPanel">Add Response';
                if (AmlCaViewModel.ControlsAccess()) {
                    SfHtml += '<button id="SaveResponseRangebtn" style="margin-right:1em" class="btn btn-primary font-xxsmall pull-right addSubFactorBtn" data-bind="click: $root.SaveSubResponseFunctionality" title="Click to add new Risk SubFactor">' +
                        '<i class="fa fa-check"></i>';
                    //SfHtml += "Save";
                    SfHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton') == -1) ? 'Save' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveButton')].Name();
                    SfHtml += '</button>';
                }
                SfHtml += '</h5>' +
                    '</div>' +
                    '</div>' +
                    '<div class="subfactor-margin">' +
                    '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th style="display:none;padding:8px 52px!important">Response ID</th>' +
                    '<th style="padding:8px 52px!important">';


                SfHtml += //Response Name
                    (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseName') == -1) ? 'Response Name' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseName')].Name();
                SfHtml += '</th > ' +
                    '<th style="padding:8px 52px!important">';

                SfHtml += //Response Score
                    (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseScore') == -1) ? 'Response Score' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseScore')].Name();

                SfHtml += '</th > ' +
                    '<th style="padding:8px 52px!important">'

                SfHtml += //Calculation Applicability
                    (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability') == -1) ? 'Calculation Applicability' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CalculationApplicability')].Name();
                SfHtml += '</th > ' +
                    '<th style="padding:8px 52px!important" class="actions">';

                SfHtml += (!AmlCaViewModel.LocaleCheckFlag() || AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : AmlCaViewModel.ObjGeneralSettings.LocalizedTextList()[AmlCaViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();
                //Actions

                SfHtml += '</th > ' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: ResposneSublevelList">' +
                    '<tr>' +
                    '<td style="display:none" data-bind="text: Id"></td>' +
                    '<td>     <input type="text" class="form-control" placeholder="Response" data-bind="value: Response, attr: {"id": Id}" /></td>' +
                    '<td><input type="text" class="form-control" data-bind="value: Score"></td>' +
                    '<td><label class="cc-checkbox">' +
                    '<input type="checkbox" id="responseapplicability" placeholder="Response applicability" data-bind="checked: CalculationApplicability">' +
                    ' <span class="cc-facet-result-text tag-text"></span>' +
                    '</label></td>' +
                    '<td class="text-center">' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>';

                return SfHtml;


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function checkExpandedRow(row, isPaginating) {
            try {
                var rowsInTable = $('#ControllevelResponseTable').find('tr');
                if (isPaginating)
                    currentRowIndex = -1;
                else
                    currentRowIndex = row.index();
                var info = RfTableObj.page.info();
                for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                    var tr = $('#ControllevelResponseTable').find('tr').get(i);
                    if (RfTableObj.row(tr).index() != row.index()) {
                        var tableRowIndex = (info.page * info.length) + (i - 1);

                        if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                            RfTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown')
                            j = $('#ControllevelResponseTable').find('tr').length;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function closeAllExpandedRows() {
            try {
                var rowsInTable = $('#ControllevelResponseTable').find('tr');
                var info = RfTableObj.page.info();
                for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                    var tr = $('#ControllevelResponseTable').find('tr').get(i);
                    var tableRowIndex = (info.page * info.length) + (i - 1);

                    if ((RfTableObj.row(tableRowIndex).child() != undefined) && (RfTableObj.row(tableRowIndex).child.isShown())) {
                        RfTableObj.row(tableRowIndex).child.remove();
                        tr.removeAttribute('class', 'shown');
                        j = $('#ControllevelResponseTable').find('tr').length;

                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeAllExpandedRows() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetallSubResponses(ID) {
            try {
                return $.ajax({
                    url: "/api/Visualization/GetControlResponseLevelRange",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { ResponseParentId: ID, QuestionId: 0, ScenarioId: AmlCaViewModel.SelectedScenarioId() }
                })
                    .success(function (jsonResult, error) {
                        AmlCaViewModel.ResposneSublevelList([]);
                        if (jsonResult != null) {

                            if (jsonResult.length != 0) {


                                var MappedResponseLevels = $.map(jsonResult, function (result) {
                                    return new ResponseDataModel(result);
                                });
                                AmlCaViewModel.ResposneSublevelList([]);
                                AmlCaViewModel.ResposneSublevelList(MappedResponseLevels);
                            }
                            else {
                                ResponseSublvlAddButton();
                            }
                        }
                        else {
                            ResponseSublvlAddButton();
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while fetching the Response level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteRiskSubResponseLevelFunctionality() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function SaveSubResponseFunctionality() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/SaveControlResponseRangeLevel?ScenarioId=" + AmlCaViewModel.SelectedScenarioId(),
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(AmlCaViewModel.ResposneSublevelList(), function (item) {
                        return { Id: item.Id(), CalculationApplicability: item.CalculationApplicability() == true ? 1 : 0, ResponseParentID: AmlCaViewModel.SelectedResponseId(), Response: item.Response(), Score: item.Score() };
                    }))
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Control Response Level details added  successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                            GetallSubResponses(AmlCaViewModel.SelectedResponseId())
                        }
                        else {
                            logger.logError('An error has occurred while adding the Control Response Level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);

                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while adding the Control Response Level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSubResponseFunctionality() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function SaveResponseSubLevel(data, event) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/ControlArea/SaveControlResponseRangeLevelWithLanguage",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: { Id: AmlCaViewModel.NewResponseLevelModel().Id(), CalculationApplicability: AmlCaViewModel.NewResponseLevelModel().CalculationApplicability() == true ? 1 : 0, ResponseParentID: AmlCaViewModel.SelectedResponseId(), Response: AmlCaViewModel.NewResponseLevelModel().Response(), Score: AmlCaViewModel.NewResponseLevelModel().Score() }
                })
                    .success(function (jsonResult, error) {
                        if (parseInt(jsonResult) > 0) {
                            logger.logSuccess('Control Response Level details added  successfully.', 'Success', system.getModuleId(AmlCaViewModel), true);
                            ('#frmControlSubResponse').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetallSubResponses(AmlCaViewModel.SelectedResponseId());
                        }
                        else {
                            logger.logError('An error has occurred while adding the Control Response Level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                            ('#frmControlSubResponse').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                        }
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while adding the Control Response Level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                        ('#frmControlSubResponse').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveResponseSubLevel() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }


        function addSubResponseFunctionality(data) {
            try {
                var NewModel = new ResponseDataModel({ Id: '999', Score: 0, Response: "", Flag: 'NEW', CalculationApplicability: 0 })
                AmlCaViewModel.ResposneSublevelList.push(NewModel);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addSubResponseFunctionality() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function deleteSubResponseFunctionality(data) {
            try {
                app.showMessage('Are you sure you want to Delete this Response Level?' + "<br/><br/><b>", 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteSubResponseItem(data);

                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: deleteSubResponseFunctionality() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        //----------------------------------------------------Logic to Handle Control Questions Ends Here---------------------------------------------------------------------------------

        //----------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------------------------------
        function ControlAreaSortOrderModel(item) {
            try {
                var self = this;
                self.ControlAreaId = ko.observable(item.ControlAreaId);

                if (item.ControlAreaName.length > 0)
                    self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());
                else
                    self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());

                self.SortOrder = AmlCaViewModel.ControlAreaSortOrder() + 1;
                AmlCaViewModel.ControlAreaSortOrder(AmlCaViewModel.ControlAreaSortOrder() + 1);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlAreaSortOrderModel() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ControlSubAreaSortOrderModel(item) {
            try {
                var self = this;
                self.ControlAreaId = ko.observable(item.ControlAreaId);

                if (item.ControlAreaName.length > 0)
                    self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());
                else
                    self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());

                self.SortOrder = AmlCaViewModel.ControlSubAreaSortOrder() + 1;
                AmlCaViewModel.ControlSubAreaSortOrder(AmlCaViewModel.ControlSubAreaSortOrder() + 1);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlSubAreaSortOrderModel() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ControlAreaModel(item) {
            try {
                var self = this;
                self.ControlAreaId = ko.observable(item.ControlAreaId);
                self.ControlAreaName = ko.observable($('<div/>').html(item.ControlAreaName).text());
                self.hasSubArea = ko.observable(item.hasSubArea);
                if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                    var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                        return new AssessmentModel(result);
                    });
                }
                self.MappedAssessmentType = ko.observableArray(MappedAssessments);
                self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
                self.ControlAreaNotes = ko.observable($('<div/>').html(item.ControlAreaNotes).text());
                self.ControlAreaDescription = ko.observable($('<div/>').html(item.ControlDescription).text());
                self.ControlArealongName = ko.observable($('<div/>').html(item.ControlAreaName).text());
                self.ControlAreaSubList = ko.observableArray(item.ControlAreaSubList);
                self.ControlResponseSubSubList = null; //ko.observableArray(ControlResponseSubSubList);
                self.ZATIdList = ko.observable(item.ZATIdList);
                self.ZATNames = ko.observable(item.ZATNames);
                self.controlAreaSelected = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlAreaModel() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ResponseOptionModel(item) {
            try {
                var self = this;

                self.ResponseTypeId = ko.observable(item.ResponseTypeId);
                self.ResponseTypeName = ko.observable(item.ResponseTypeName);
                self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
        function ControlSubAreaModel(item) {
            try {
                var self = this;
                self.ControlAreaId = ko.observable(item.ControlAreaId);
                self.ControlAreaName = ko.observable($('<div/>').html(item.ControlArealongName).text());
                self.hasSubArea = ko.observable(item.hasSubArea);
                if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                    var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                        return new AssessmentModel(result);
                    });
                }
                self.MappedAssessmentType = ko.observableArray(MappedAssessments);
                self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
                self.ControlAreaNotes = ko.observable($('<div/>').html(item.ControlAreaNotes).text());
                self.ControlAreaDescription = ko.observable($('<div/>').html(item.ControlDescription).text());
                self.ControlArealongName = ko.observable($('<div/>').html(item.ControlAreaName).text());
                self.ControlSubAreaSubList = ko.observableArray(item.ControlAreaSubList);
                self.ParentAreaId = ko.observable(item.ParentAreaId);
                self.ZATIdList = ko.observable(item.ZATIdList);
                self.ZATNames = ko.observable(item.ZATNames);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlSubAreaModel() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentModel(item) {
            try {
                var self = this;
                if (isNaN(item)) {
                    self.ID = item.IDt
                }
                else {
                    self.ID = item;
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentListModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                self.AssessmentName = ko.observable(item.AssessmentName);
                self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
                self.Description = ko.observable($('<div/>').html(item.Description).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ControlQuestionSortOrderDupModel(item) {
            try {
                var self = this;
                self.ControlQuestionId = ko.observable(item.ControlQuestionId());
                self.ControlQuestionName = ko.observable($('<div/>').html(item.ControlQuestionName()).text())
                self.SortOrder = ko.observable(item.SortOrder);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ControlQuestionSortOrderDupModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ControlQuestionSortModel(item) {
            var self = this;
            self.ControlQuestionId = ko.observable(item.ControlQuestionId);
            self.ControlQuestionName = ko.observable($('<div/>').html(item.ControlQuestionName).text());
            self.SortOrder = AmlCaViewModel.ControlQuestionSortOrder() + 1;
            AmlCaViewModel.ControlQuestionSortOrder(AmlCaViewModel.ControlQuestionSortOrder() + 1);
        }
        function ControlQuestionModel(item) {
            var self = this;
            self.ControlQuestionId = ko.observable(item.ControlQuestionId);
            self.AssessmentIdList = ko.observable(item.AssessmentIdList);
            self.AssessmentType = ko.observable(item.AssessmentType);
            self.RiskAssesmentList = ko.observable(item.RISK_ASSESSMENT_ID);
            self.ControlQuestionNamen = ko.observable($('<div/>').html(item.ControlQuestionNameNconcat).text());
            self.OEQuestiondata = ko.observable($('<div/>').html(item.OEQuestiondata).text());
            self.CDQuestiondata = ko.observable($('<div/>').html(item.CDQuestiondata).text());
            self.ControlQuestionName = ko.observable($('<div/>').html($('<div/>').html(item.ControlQuestionName).text()).text());
            self.ResponseApplicability = ko.observable(item.ResponseApplicability);
            self.ControlDesign = ko.observable(item.ControlDesign);
            self.OperatingEffectiveness = ko.observable(item.OperatingEffectiveness);
            self.NotApplicable = ko.observable(item.NotApplicable);
            self.NAQuestionData = ko.observable(item.NAQuestionData);
            self.ControlAreaType = ko.observable($('<div/>').html(item.ControlAreaType).text());
            self.ControlAreaIDList = ko.observable(item.CONTROL_AREA_ID);
            self.ControlFactorLanguageList = ko.observableArray(item.ControlFactorLanguageList);
            self.ControlQuestionList = ko.observableArray(item.ControlQuestionList);
            self.ResponseQuestionName = ko.observable($('<div/>').html(item.ResponseQuestionName).text());
            self.ControlReferenceId = ko.observable(item.ControlReferenceId);
            self.ReadOnlyTypeControl = ko.observable(item.ReadOnlyTypeControl);
            self.HeaderTypeControl = ko.observable(item.HeaderTypeControl);
            self.ConditionalTypeControl = ko.observable(item.ConditionalTypeControl);
            self.ParentControlQuestionId = ko.observable(item.ParentControlQuestionId);
            self.ParentControlQuestionName = ko.observable($('<div/>').html(item.ParentControlQuestionName).text());
            self.QuestionTypeText = ko.observable(item.QuestionTypeText);
            self.ControlResponseId = ko.observable(item.ControlResponseId);
            self.ControlQuestionTextConcat = ko.observable($('<div/>').html(item.ControlQuestionTextConcat).text());
            self.AlwaysVisible = ko.observable(item.AlwaysVisible);
            self.ResponseApplicableFlag = ko.observable(item.ResponseApplicableFlag);
            self.QuestionGuideline = ko.observable(item.QuestionGuideline);
            self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
            if (item.ResponseOptionTypeModelObject != null) {
                self.ResponseOptionTypeList = $.map(item.ResponseOptionTypeModelObject, function (result) {
                    return new ResponseOptionModel(result);
                });
            }

        }

        function FilteredAssessmentListModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
                self.AssessmentName = ko.observable(item.AssessmentName());
                self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
                self.Description = ko.observable($('<div/>').html(item.Description()).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FilteredAssessmentListModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function ResponselevelModel(item, langID, langName) {
            try {
                var self = this;
                self.Id = ko.observable($('<div/>').html(item.Id).text());
                self.Response = ko.observable();
                if (langName == undefined || langName == null)
                    self.Response($('<div/>').html(item.Response).text());
                else
                    self.Response(item.Response + " (" + langName + ")");
                self.Description = ko.observable($('<div/>').html(item.Description).text());
                self.Response_weightage = ko.observable($('<div/>').html(item.Response_weightage).text());
                self.Response_Ref_Id = ko.observable(item.Response_Ref_Id);
                self.GlobalFlag = ko.observable(item.GlobalFlag);
                self.WeightedAverage = ko.observable(item.WeightedAverage);
                if (item.ResponseQuestionVisble)
                    self.ResponseQuestionVisble = ko.observable(item.ResponseQuestionVisble);
                else
                    self.ResponseQuestionVisble = ko.observable(false);
                self.ResponseQuestionText = ko.observable().extend({
                    required: {
                        message: self.Response() + " text is required.",
                        onlyIf: function () {
                            if (self.ResponseQuestionVisble() === true && self.Response() !== 'Short Question')
                                return true;
                            else
                                return false;
                        }
                    }
                });
                self.langID = ko.observable(0);
                if (langID == undefined || langID == null)
                    self.langID(0);
                else
                    self.langID(langID);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponselevelModel() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        //----------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------------------------

        function GetLanguageName(languageId) {
            if (AmlCaViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                AmlCaViewModel.ObjGeneralSettings.getLanguages();
            }
            for (var i = 0; i < AmlCaViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                if (AmlCaViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() === languageId)
                    return AmlCaViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
            }
            return ""; // The object was not found
        }

        //code to mark question type as readonly or header type while adding a factor
        function QuestionTypeChangedFactor(data, event) {
            try {
                //Toggle the factor type flags
                document.getElementById(event.currentTarget.id).checked = true;
                if (event.currentTarget.value == "ReadOnlyTypeControl") {
                    AmlCaViewModel.FactorReadOnlyType(true);
                    AmlCaViewModel.FactorHeaderType(false);
                    document.getElementById("ReadOnlyTypeControl").checked = true;
                    if (AmlCaViewModel.AddConditionalQuestionType() == false) {
                        document.getElementById("HeaderTypeControl").checked = false;
                        AmlCaViewModel.ResponseOptionddFlag(false);
                    }

                    RemoveHeaderTypeQuestion();
                    $('#RAControlFactorLanguage').multiselect('refresh');
                    AmlCaViewModel.SelectedLanguageCntrlFactorType([]);
                }
                else if (event.currentTarget.value == "HeaderTypeControl") {
                    AmlCaViewModel.FactorReadOnlyType(false);
                    AmlCaViewModel.FactorHeaderType(true);
                    document.getElementById("ReadOnlyTypeControl").checked = false;
                    document.getElementById("HeaderTypeControl").checked = true;

                    AddHeaderTypeQuestion();
                }
                else {
                    AmlCaViewModel.FactorReadOnlyType(false);
                    AmlCaViewModel.FactorHeaderType(false);
                    RemoveHeaderTypeQuestion();
                    AmlCaViewModel.ResponseOptionddFlag(true);
                }
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuestionTypeChangedFactor() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function resetRadioButtons(data, event) {
            try {
                AmlCaViewModel.FactorReadOnlyType(false);
                AmlCaViewModel.FactorHeaderType(false);
                document.getElementById("ReadOnlyTypeControl").checked = false;
                document.getElementById("HeaderTypeControl").checked = false;
                RemoveHeaderTypeQuestion();
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: resetRadioButtons() method in ControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetAllSubResponsesForConditionalType(ID) {
            return $.ajax({
                url: "/api/ControlArea/GetControlResponseLevelRange",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ResponseParentId: ID, QuestionId: AmlCaViewModel.ControlQuestionId() }
            })
                .success(function (jsonResult, error) {
                    AmlCaViewModel.ResposneAddSublevelList([]);
                    if (jsonResult != null && jsonResult.length != 0) {
                        var MappedResponseLevels = $.map(jsonResult, function (result) {
                            return new ResponseConditionalDataModel(result);
                        });
                        AmlCaViewModel.ResposneAddSublevelList([]);
                        AmlCaViewModel.ResposneAddSublevelList(MappedResponseLevels);
                    }
                    $("#ControlResponseOptions").multiselect();
                    $('#ControlResponseOptions').multiselect('refresh');
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the Response level. Please contact your Administrator.', 'Error', system.getModuleId(AmlCaViewModel), true);
                });
        }
        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }
        function ZATRATModel(ZATID, ZATNAME, RATID, ZATShortName) {
            try {
                var self = this;
                self.ZAT_UID = ko.observable(ZATID);
                self.ZATName = ko.observable(ZATNAME);
                self.RAT_UID = ko.observable(RATID);
                self.ZATShortName = ko.observable(ZATShortName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ZATRATModel() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }


        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (AmlCaViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(AmlCaViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
        }

    });
